export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const PragmaticPlayGames = {
  // PlushieWins: {
  //   href: "/casino/pp-plushie-wins",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/Plushire-wins.png",
  //   alt: "Plushie Wins",
  //   name: "Plushie Wins",
  //   providerName: "Vivo",
  // },
  // MummysJewels: {
  //   href: "/casino/pp-mummys-jewels",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/Mummys-jewel.jpg",
  //   alt: "Mummy’s Jewels",
  //   name: "Mummy’s Jewels",
  //   providerName: "Vivo",
  // },
  // CasinoHoldem: {
  //   href: "/casino/pp-casino-holdem",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/Casino-Holdem.png",
  //   alt: "Casino Hold’em",
  //   name: "Casino Hold’em",
  //   providerName: "Vivo",
  // },
  // TrumpCardQueen: {
  //   href: "/casino/pp-trump-card-queen",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/Trump-card-qeen.jpg",
  //   alt: "Trump Card: Queen",
  //   name: "Trump Card: Queen",
  //   providerName: "Vivo",
  // },
  // SaiyanMania: {
  //   href: "/casino/pp-saiyan-mania",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/SaiyanMania.webp",
  //   alt: "Saiyan Mania",
  //   name: "Saiyan Mania",
  //   providerName: "Vivo",
  // },
  // Piggies725000: {
  //   href: "/casino/pp-7-piggies-25000",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/7Piggies25000.webp",
  //   alt: "7 Piggies 25,000",
  //   name: "7 Piggies 25,000",
  //   providerName: "Vivo",
  // },
  // HotSafari75000: {
  //   href: "/casino/pp-hot-safari-75000",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/HotSafari75000.webp",
  //   alt: "Hot Safari 75,000",
  //   name: "Hot Safari 75,000",
  //   providerName: "Vivo",
  // },
  // PandaGold50000: {
  //   href: "/casino/pp-panda-gold-50000",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/PandaGold50000.webp",
  //   alt: "Panda Gold 50,000",
  //   name: "Panda Gold 50,000",
  //   providerName: "Vivo",
  // },
  // WolfGold1000000: {
  //   href: "/casino/pp-wolf-gold-1000000",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/WolfGold1000000.webp",
  //   alt: "Wolf Gold 1,000,000",
  //   name: "Wolf Gold 1,000,000",
  //   providerName: "Vivo",
  // },
  // QueenofGold100000: {
  //   href: "/casino/pp-queen-of-gold-100000",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/QueenofGold100000.webp",
  //   alt: "Queen of Gold 100,000",
  //   name: "Queen of Gold 100,000",
  //   providerName: "Vivo",
  // },
  // DiamondStrike250000: {
  //   href: "/casino/pp-diamond-strike-250000",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/DiamondStrike250000.webp",
  //   alt: "Diamond Strike 250,000",
  //   name: "Diamond Strike 250,000",
  //   providerName: "Vivo",
  // },
  // GoldRush500000: {
  //   href: "/casino/pp-gold-rush-500000",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/GoldRush500000.webp",
  //   alt: "Gold Rush 500,000",
  //   name: "Gold Rush 500,000",
  //   providerName: "Vivo",
  // },
  // LobsterBobsCrazyCrabShack: {
  //   href: "/casino/pp-lobster-bobs-crazy-crab-shack",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/LobsterBobsCrazyCrabShack.webp",
  //   alt: "Lobster Bob's Crazy Crab Shack",
  //   name: "Lobster Bob's Crazy Crab Shack",
  //   providerName: "Vivo",
  // },
  gemsofserengeti: {
    href: "/casino/pragmaticplay-gems-of-serengeti",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GemsofSerengeti.webp",
    alt: "Gems of Serengeti",
    name: "Gems of Serengeti",
    providerName: "Vivo",
  },
  africanelephant: {
    href: "/casino/pragmaticplay-african-elephant",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/AfricanElephant.webp",
    alt: "African Elephant",
    name: "African Elephant",
    providerName: "Vivo",
  },
  timberstacks: {
    href: "/casino/pragmaticplay-timber-stacks",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TimberStacks.webp",
    alt: "Timber Stacks",
    name: "Timber Stacks",
    providerName: "Vivo",
  },
  theredqueen: {
    href: "/casino/pragmaticplay-the-red-queen",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheRedQueen.webp",
    alt: "The Red Queen",
    name: "The Red Queen",
    providerName: "Vivo",
  },
  goodluckgoodfortune: {
    href: "/casino/pragmaticplay-good-luck-and-good-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GoodLuck&GoodFortune.webp",
    alt: "Good Luck & Good Fortune",
    name: "Good Luck & Good Fortune",
    providerName: "Vivo",
  },
  // ChaseForGlory: {
  //   href: "/casino/pp-chase-for-glory",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/chaseforglory.webp",
  //   alt: "Chase For Glory",
  //   name: "Chase For Glory",
  //   providerName: "Vivo",
  // },
  // kingdomofthedead: {
  //   href: "/casino/pragmaticplay-kingdom-of-the-dead",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/KingdomofTheDead.webp",
  //   alt: "Kingdom of The Dead",
  //   name: "Kingdom of The Dead",
  //   providerName: "Vivo",
  // },
  demonpots: {
    href: "/casino/pragmaticplay-demon-pots",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/DemonPots.webp",
    alt: "Demon Pots",
    name: "Demon Pots",
    providerName: "Vivo",
  },
  jasminedreams: {
    href: "/casino/pragmaticplay-jasmine-dreams",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JasmineDreams.webp",
    alt: "Jasmine Dreams",
    name: "Jasmine Dreams",
    providerName: "Vivo",
  },
  dingdongchristmasbells: {
    href: "/casino/pragmaticplay-ding-dong-christmas-bells",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/DingDongChristmasBells.webp",
    alt: "Ding Dong Christmas Bells",
    name: "Ding Dong Christmas Bells",
    providerName: "Vivo",
  },
  theknightking: {
    href: "/casino/pragmaticplay-the-knight-king",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/KnightKing.webp",
    alt: "The Knight King",
    name: "The Knight King",
    providerName: "Vivo",
  },
  strikinghot5: {
    href: "/casino/pragmaticplay-striking-hot-5",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/StrikingHot5.webp",
    alt: "Striking Hot 5",
    name: "Striking Hot 5",
    providerName: "Vivo",
  },
  diamondcascade: {
    href: "/casino/pragmaticplay-diamond-cascade",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/DiamondCascade.webp",
    alt: "Diamond Cascade",
    name: "Diamond Cascade",
    providerName: "Vivo",
  },
  // OldGoldMinerMegaways: {
  //   href: "/casino/pp-old-gold-miner-megaways",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/OldGoldMinerMegaways.webp",
  //   alt: "Old Gold Miner Megaways",
  //   name: "Old Gold Miner Megaways",
  //   providerName: "Vivo",
  // },
  frogsbugs: {
    href: "/casino/pragmaticplay-frogs-and-bugs",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Frogs&Bugs.webp",
    alt: "Frogs & Bugs",
    name: "Frogs & Bugs",
    providerName: "Vivo",
  },
  // TundrasFortune: {
  //   href: "/casino/pp-tundras-fortune",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/TundrasFortune.webp",
  //   alt: "Tundras Fortune",
  //   name: "Tundras Fortune",
  //   providerName: "Vivo",
  // },
  piggybankers: {
    href: "/casino/pragmaticplay-piggy-bankers",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PiggyBankers.webp",
    alt: "Piggy Bankers",
    name: "Piggy Bankers",
    providerName: "Vivo",
  },
  hellviswild: {
    href: "/casino/pragmaticplay-hellvis-wild",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HellvisWild.webp",
    alt: "Hellvis Wild",
    name: "Hellvis Wild",
    providerName: "Vivo",
  },
  wildwildbananas: {
    href: "/casino/pragmaticplay-wild-wild-bananas",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WildWildBananas.webp",
    alt: "Wild Wild Bananas",
    name: "Wild Wild Bananas",
    providerName: "Vivo",
  },
  // JaneHunterandtheMaskofMontezuma: {
  //   href: "/casino/pp-jane-hunter-and-the-mask-of-montezuma",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/JaneHunterandtheMaskofMontezuma.webp",
  //   alt: "Jane Hunter and the Mask of Montezuma",
  //   name: "Jane Hunter and the Mask of Montezuma",
  //   providerName: "Vivo",
  // },
  crownoffire: {
    href: "/casino/pragmaticplay-crown-of-fire",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CrownofFire.webp",
    alt: "Crown of Fire",
    name: "Crown of Fire",
    providerName: "Vivo",
  },
  knighthotspotz: {
    href: "/casino/pragmaticplay-knight-hot-spotz",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/KnightHotSpotz.webp",
    alt: "Knight Hot Spotz",
    name: "Knight Hot Spotz",
    providerName: "Vivo",
  },
  toweringfortunes: {
    href: "/casino/pragmaticplay-towering-fortunes",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ToweringFortunes.webp",
    alt: "Towering Fortunes",
    name: "Towering Fortunes",
    providerName: "Vivo",
  },
  gemstone: {
    href: "/casino/pragmaticplay-gemstone",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Gemstone.webp",
    alt: "Gemstone",
    name: "Gemstone",
    providerName: "Vivo",
  },
  mightymunchingmelons: {
    href: "/casino/pragmaticplay-mighty-munching-melons",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MightyMunchingMelons.webp",
    alt: "Mighty Munching Melons",
    name: "Mighty Munching Melons",
    providerName: "Vivo",
  },
  goldoasis: {
    href: "/casino/pragmaticplay-gold-oasis",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GoldOasis.webp",
    alt: "Gold Oasis",
    name: "Gold Oasis",
    providerName: "Vivo",
  },
  secretcitygold: {
    href: "/casino/pragmaticplay-secret-city-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SecretCityGold.webp",
    alt: "Secret City Gold",
    name: "Secret City Gold",
    providerName: "Vivo",
  },
  LokisRiches: {
    href: "/casino/pragmaticplay-lokis-riches",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/LokisRiches.webp",
    alt: "Loki's Riches",
    name: "Loki's Riches",
    providerName: "Vivo",
  },
  vegasmagic: {
    href: "/casino/pragmaticplay-vegas-magic",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/VegasMagic.webp",
    alt: "Vegas Magic",
    name: "Vegas Magic",
    providerName: "Vivo",
  },
  pirategoldenage: {
    href: "/casino/pragmaticplay-pirate-golden-age",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PirateGoldenAge.webp",
    alt: "Pirate Golden Age",
    name: "Pirate Golden Age",
    providerName: "Vivo",
  },
  cashbox: {
    href: "/casino/pragmaticplay-cash-box",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CashBox.webp",
    alt: "Cash Box",
    name: "Cash Box",
    providerName: "Vivo",
  },
  frozentropics: {
    href: "/casino/pragmaticplay-frozen-tropics",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FrozenTropics.webp",
    alt: "Frozen Tropics",
    name: "Frozen Tropics",
    providerName: "Vivo",
  },
  LobsterBobSeaFoodandWinIt: {
    href: "/casino/pragmaticplay-lobster-bobs-sea-food-and-win-it",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/LobsterBobsSeaFoodandWinIt.webp",
    alt: "Lobster Bob's Sea Food and Win It",
    name: "Lobster Bob's Sea Food and Win It",
    providerName: "Vivo",
  },
  // "Master Chen's Fortune": {
  //   href: "/casino/pp-master-chens-fortune",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/MasterChensFortune.webp",
  //   alt: "Master Chen's Fortune",
  //   name: "Master Chen's Fortune",
  //   providerName: "Vivo",
  // },
  LampOfInfinity: {
    href: "/casino/pragmaticplay-laughing-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/LampOfInfinity.webp",
    alt: "Lamp Of Infinity",
    name: "Lamp Of Infinity",
    providerName: "Vivo",
  },
  cyclopssmash: {
    href: "/casino/pragmaticplay-cyclops-smash",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CyclopsSmash.webp",
    alt: "Cyclops Smash",
    name: "Cyclops Smash",
    providerName: "Vivo",
  },

  gatesofolympus: {
    href: "/casino/pragmaticplay-gates-of-olympus",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GatesofOlympus.webp",
    alt: "Gates of Olympus",
    name: "Gates of Olympus",
    providerName: "Vivo",
  },
  sweetbonanza: {
    href: "/casino/pragmaticplay-sweet-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SweetBonanza.webp",
    alt: "Sweet Bonanza",
    name: "Sweet Bonanza",
    providerName: "Vivo",
  },
  sugarrush: {
    href: "/casino/pragmaticplay-sugar-rush",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SugarRush.webp",
    alt: "Sugar Rush",
    name: "Sugar Rush",
    providerName: "Vivo",
  },
  bigbassbonanza: {
    href: "/casino/pragmaticplay-big-bass-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BigBassBonanza.webp",
    alt: "Big Bass Bonanza",
    name: "Big Bass Bonanza",
    providerName: "Vivo",
  },
  bigbasshalloween: {
    href: "/casino/pragmaticplay-big-bass-halloween",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BigBassHalloween.webp",
    alt: "Big Bass Halloween",
    name: "Big Bass Halloween",
    providerName: "Vivo",
  },
  bigbasssplash: {
    href: "/casino/pragmaticplay-big-bass-splash",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BigBassSplash.webp",
    alt: "Big Bass Splash",
    name: "Big Bass Splash",
    providerName: "Vivo",
  },
  thedoghouse: {
    href: "/casino/pragmaticplay-the-dog-house",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheDogHouse.webp",
    alt: "The Dog House",
    name: "The Dog House",
    providerName: "Vivo",
  },
  gatesofhades: {
    href: "/casino/pragmaticplay-gates-of-hades",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GatesofHades.webp",
    alt: "Gates of Hades",
    name: "Gates of Hades",
    providerName: "Vivo",
  },
  zombieschoolmegaways: {
    href: "/casino/pragmaticplay-zombie-school-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ZombieSchoolMegaways.webp",
    alt: "Zombie School Megaways",
    name: "Zombie School Megaways",
    providerName: "Vivo",
  },
  zombiecarnival: {
    href: "/casino/pragmaticplay-zombie-carnival",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ZombieCarnival.webp",
    alt: "Zombie Carnival",
    name: "Zombie Carnival",
    providerName: "Vivo",
  },
  zeusvshadesgodsofwar: {
    href: "/casino/pragmaticplay-zeus-vs-hades-gods-of-war",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ZeusvsHades-GodsofWar.webp",
    alt: "Zeus vs Hades  Gods of War",
    name: "Zeus vs Hades  Gods of War",
    providerName: "Vivo",
  },
  youcanpiggybankonit: {
    href: "/casino/pragmaticplay-you-can-piggy-bank-on-it",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/YouCanPiggyBankonIt.webp",
    alt: "You Can Piggy Bank On It",
    name: "You Can Piggy Bank On It",
    providerName: "Vivo",
  },
  yollarinkrali: {
    href: "/casino/pragmaticplay-yollarin-krali",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/YollarinKrali.webp",
    alt: "Yollarin Krali",
    name: "Yollarin Krali",
    providerName: "Vivo",
  },
  yisunshin: {
    href: "/casino/pragmaticplay-yi-sun-shin",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/YiSunShin.webp",
    alt: "Yi Sun Shin",
    name: "Yi Sun Shin",
    providerName: "Vivo",
  },
  yetiquest: {
    href: "/casino/pragmaticplay-yeti-quest",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/YetiQuest.webp",
    alt: "Yeti Quest",
    name: "Yeti Quest",
    providerName: "Vivo",
  },
  yearofthedragonking: {
    href: "/casino/pragmaticplay-year-of-the-dragon-king",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/YearofTheDragonKing.webp",
    alt: "Year Of The Dragon King",
    name: "Year Of The Dragon King",
    providerName: "Vivo",
  },
  yabotreeofriches: {
    href: "/casino/pragmaticplay-yabo-tree-of-riches",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/YaboTreeofRiches.webp",
    alt: "Yabo Tree of Riches",
    name: "Yabo Tree of Riches",
    providerName: "Vivo",
  },
  xmasspark: {
    href: "/casino/pragmaticplay-xmas-spark",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/XmasSpark.webp",
    alt: "Xmas Spark",
    name: "Xmas Spark",
    providerName: "Vivo",
  },
  wukongrush: {
    href: "/casino/pragmaticplay-wukong-rush",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WukongRush.webp",
    alt: "Wukong Rush",
    name: "Wukong Rush",
    providerName: "Vivo",
  },
  wolfgoldultimate: {
    href: "/casino/pragmaticplay-wolf-gold-ultimate",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WolfGoldUltimate.webp",
    alt: "Wolf Gold Ultimate",
    name: "Wolf Gold Ultimate",
    providerName: "Vivo",
  },
  wolfgolddice: {
    href: "/casino/pragmaticplay-wolf-gold-dice",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WolfGoldDice.webp",
    alt: "Wolf Gold Dice",
    name: "Wolf Gold Dice",
    providerName: "Vivo",
  },
  wolfgold4pack: {
    href: "/casino/pragmaticplay-wolf-gold-4-pack",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WolfGold4Pack.webp",
    alt: "Wolf Gold 4 Pack",
    name: "Wolf Gold 4 Pack",
    providerName: "Vivo",
  },
  wolfgold: {
    href: "/casino/pragmaticplay-wolf-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WolfGold.webp",
    alt: "Wolf Gold",
    name: "Wolf Gold",
    providerName: "Vivo",
  },
  witchheartmegaways: {
    href: "/casino/pragmaticplay-witch-heart-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WitchHeartMegaways.webp",
    alt: "Witch Heart Megaways",
    name: "Witch Heart Megaways",
    providerName: "Vivo",
  },
  wisdomofathena1000: {
    href: "/casino/pragmaticplay-wisdom-of-athena-1000",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WisdomofAthena1000.webp",
    alt: "Wisdom Of Athena 1000",
    name: "Wisdom Of Athena 1000",
    providerName: "Vivo",
  },
  wisdomofathena: {
    href: "/casino/pragmaticplay-wisdom-of-athena",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WisdomofAthena.webp",
    alt: "Wisdom of Athena",
    name: "Wisdom of Athena",
    providerName: "Vivo",
  },
  wildmansuperbonanza: {
    href: "/casino/pragmaticplay-wildman-super-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WildmanSuperBonanza.webp",
    alt: "Wildman Super Bonanza",
    name: "Wildman Super Bonanza",
    providerName: "Vivo",
  },
  wildies: {
    href: "/casino/pragmaticplay-wildies",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Wildies.webp",
    alt: "Wildies",
    name: "Wildies",
    providerName: "Vivo",
  },
  wildwildebeestwins: {
    href: "/casino/pragmaticplay-wild-wildebeest-wins",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WildWildebeestWins.webp",
    alt: "Wild Wildebeest Wins",
    name: "Wild Wildebeest Wins",
    providerName: "Vivo",
  },
  wildwildwolf: {
    href: "/casino/pragmaticplay-wild-wild-wolf",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WildWildWolf.webp",
    alt: "Wild Wild Wolf",
    name: "Wild Wild Wolf",
    providerName: "Vivo",
  },
  wildwildriches: {
    href: "/casino/pragmaticplay-wild-wild-riches",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WildWildRiches.webp",
    alt: "Wild Wild Riches",
    name: "Wild Wild Riches",
    providerName: "Vivo",
  },
  wildwildpearls: {
    href: "/casino/pragmaticplay-wild-wild-pearls",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WildWildPearls.webp",
    alt: "Wild Wild Pearls",
    name: "Wild Wild Pearls",
    providerName: "Vivo",
  },
  wildwildjoker: {
    href: "/casino/pragmaticplay-wild-wild-joker",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WildWildJoker.webp",
    alt: "Wild Wild Joker",
    name: "Wild Wild Joker",
    providerName: "Vivo",
  },
  wildwestgoldmegaways: {
    href: "/casino/pragmaticplay-wild-west-gold-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WildWestGoldMegaways.webp",
    alt: "Wild West Gold Megaways",
    name: "Wild West Gold Megaways",
    providerName: "Vivo",
  },
  wildwestgoldblazingbounty: {
    href: "/casino/pragmaticplay-wild-west-gold-blazing-bounty",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WildWestGoldBlazingBounty.webp",
    alt: "Wild West Gold Blazing Bounty",
    name: "Wild West Gold Blazing Bounty",
    providerName: "Vivo",
  },
  wildwestgold: {
    href: "/casino/pragmaticplay-wild-west-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WildWestGold.webp",
    alt: "Wild West Gold",
    name: "Wild West Gold",
    providerName: "Vivo",
  },
  wildwestbounty: {
    href: "/casino/pragmaticplay-wild-west-bounty",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WildWestBounty.webp",
    alt: "Wild West Bounty",
    name: "Wild West Bounty",
    providerName: "Vivo",
  },
  wildwalker: {
    href: "/casino/pragmaticplay-wild-walker",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WildWalker.webp",
    alt: "Wild Walker",
    name: "Wild Walker",
    providerName: "Vivo",
  },
  wildspells: {
    href: "/casino/pragmaticplay-wild-spells",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WildSpells.webp",
    alt: "Wild Spells",
    name: "Wild Spells",
    providerName: "Vivo",
  },
  wildpixies: {
    href: "/casino/pragmaticplay-wild-pixies",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WildPixies.webp",
    alt: "Wild Pixies",
    name: "Wild Pixies",
    providerName: "Vivo",
  },
  wildhopdrop: {
    href: "/casino/pragmaticplay-wild-hopanddrop",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WildHop&Drop.webp",
    alt: "Wild Hop&Drop",
    name: "Wild Hop&Drop",
    providerName: "Vivo",
  },
  wildgladiators: {
    href: "/casino/pragmaticplay-wild-gladiators",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WildGladiators.webp",
    alt: "Wild Gladiators",
    name: "Wild Gladiators",
    providerName: "Vivo",
  },
  wilddepths: {
    href: "/casino/pragmaticplay-wild-depths",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WildDepths.webp",
    alt: "Wild Depths",
    name: "Wild Depths",
    providerName: "Vivo",
  },
  wildcelebritybusmegaways: {
    href: "/casino/pragmaticplay-wild-celebrity-bus-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WildCelebrityBusMegaways.webp",
    alt: "Wild Celebrity Bus Megaways",
    name: "Wild Celebrity Bus Megaways",
    providerName: "Vivo",
  },
  wildbooster: {
    href: "/casino/pragmaticplay-wild-booster",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WildBooster.webp",
    alt: "Wild Booster",
    name: "Wild Booster",
    providerName: "Vivo",
  },
  wildbisoncharge: {
    href: "/casino/pragmaticplay-wild-bison-charge",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WildBisonCharge.webp",
    alt: "Wild Bison Charge",
    name: "Wild Bison Charge",
    providerName: "Vivo",
  },
  wildbeachxmasparty: {
    href: "/casino/pragmaticplay-wild-beach-xmas-party",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WildBeachXmasParty.webp",
    alt: "Wild Beach Xmas Party",
    name: "Wild Beach Xmas Party",
    providerName: "Vivo",
  },
  wildbeachparty: {
    href: "/casino/pragmaticplay-wild-beach-party",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WildBeachParty.webp",
    alt: "Wild Beach Party",
    name: "Wild Beach Party",
    providerName: "Vivo",
  },
  wheelogold: {
    href: "/casino/pragmaticplay-wheel-ogold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WheelOGold.webp",
    alt: "Wheel O'Gold",
    name: "Wheel O'Gold",
    providerName: "Vivo",
  },
  wavesofposeidon: {
    href: "/casino/pragmaticplay-waves-of-poseidon",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WavesofPoseidon.webp",
    alt: "Waves of Poseidon",
    name: "Waves of Poseidon",
    providerName: "Vivo",
  },

  LuckysWildPub: {
    href: "/casino/pragmaticplay-luckys-wild-pub",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/LuckysWildPub.webp",
    alt: "Lucky’s Wild Pub",
    name: "Lucky’s Wild Pub",
    providerName: "Vivo",
  },
  LuckyNewYear: {
    href: "/casino/pragmaticplay-lucky-new-year",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/LuckyNewYear.webp",
    alt: "Lucky New Year",
    name: "Lucky New Year",
    providerName: "Vivo",
  },
  LuckyLightning: {
    href: "/casino/pragmaticplay-lucky-lightning",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/LuckyLightning.webp",
    alt: "Lucky Lightning",
    name: "Lucky Lightning",
    providerName: "Vivo",
  },
  LuckyGraceAndCharm: {
    href: "/casino/pragmaticplay-lucky-grace-and-charm",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/LuckyGraceAndCharm.webp",
    alt: "Lucky Grace And Charm",
    name: "Lucky Grace And Charm",
    providerName: "Vivo",
  },
  // LuckyFishingMegaways: {
  //   href: "/casino/pragmaticplay-lucky-fishing-megaways",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/LuckyFishingMegaways.webp",
  //   alt: "Lucky Fishing Megaways",
  //   name: "Lucky Fishing Megaways",
  //   providerName: "Vivo",
  // },
  LuckyDragons: {
    href: "/casino/pragmaticplay-lucky-dragons",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/LuckyDragons.webp",
    alt: "Lucky Dragons",
    name: "Lucky Dragons",
    providerName: "Vivo",
  },
  LuckyDragonBall: {
    href: "/casino/pragmaticplay-lucky-dragon-ball",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/LuckyDragonBall.webp",
    alt: "Lucky Dragon Ball",
    name: "Lucky Dragon Ball",
    providerName: "Vivo",
  },
  LobsterBobsCrazyCrabShack: {
    href: "/casino/pragmaticplay-lobster-bobs-crazy-crab-shack",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/LobsterBobsCrazyCrabShack.webp",
    alt: "Lobster Bobs Crazy Crab Shack",
    name: "Lobster Bobs Crazy Crab Shack",
    providerName: "Vivo",
  },
  LittleGemHoldandSpin: {
    href: "/casino/pragmaticplay-waves-of-poseidon",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/LittleGemHoldandSpin.webp",
    alt: "Little Gem Hold and Spin",
    name: "Little Gem Hold and Spin",
    providerName: "Vivo",
  },
  // LeprechaunSong: {
  //   href: "/casino/pragmaticplay-leprechaun-song",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/LeprechaunSong.webp",
  //   alt: "Leprechaun Song",
  //   name: "Leprechaun Song",
  //   providerName: "Vivo",
  // },
  // LeprechaunCarol: {
  //   href: "/casino/pragmaticplay-leprechaun-carol",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/LeprechaunCarol.webp",
  //   alt: "Leprechaun Carol",
  //   name: "Leprechaun Carol",
  //   providerName: "Vivo",
  // },
  // LeprechaunCarol: {
  //   href: "/casino/pragmaticplay-legend-of-heroes",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/LegendofHeroes.webp",
  //   alt: "Legend of Heroes",
  //   name: "Legend of Heroes",
  //   providerName: "Vivo",
  // },
  LegendofGaruda: {
    href: "/casino/pragmaticplay-legend-of-garuda",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/LegendofGaruda.webp",
    alt: "Legend of Garuda",
    name: "Legend of Garuda",
    providerName: "Vivo",
  },
  LaughingFortune: {
    href: "/casino/pragmaticplay-laughing-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/LaughingFortune.webp",
    alt: "Laughing Fortune",
    name: "Laughing Fortune",
    providerName: "Vivo",
  },
  LadyBugLuck: {
    href: "/casino/pragmaticplay-ladybug-luck",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/LadyBugLuck.webp",
    alt: "LadyBug Luck",
    name: "LadyBug Luck",
    providerName: "Vivo",
  },
  // LadyGodiva: {
  //   href: "/casino/pragmaticplay-lady-godiva",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/LadyGodiva.webp",
  //   alt: "Lady Godiva",
  //   name: "Lady Godiva",
  //   providerName: "Vivo",
  // },
  ladydmegaways: {
    href: "/casino/pragmaticplay-lady-d-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/LadyDMegaways.webp",
    alt: "Lady D Megaways",
    name: "Lady D Megaways",
    providerName: "Vivo",
  },

  ladbrokesheat: {
    href: "/casino/pragmaticplay-ladbrokes-heat",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/LadbrokesHeat.webp",
    alt: "Ladbrokes Heat",
    name: "Ladbrokes Heat",
    providerName: "Vivo",
  },
  lamokawildpowernudge: {
    href: "/casino/pragmaticplay-la-moka-wild-powernudge",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/LaMokaWildPowernudge.webp",
    alt: "La Moka Wild Powernudge",
    name: "La Moka Wild Powernudge",
    providerName: "Vivo",
  },
  // koipond: {
  //   href: "/casino/pragmaticplay-koi-pond",
  //   code: "",
  //   casino: "Slots",
  //   provider: "Pragmatic Play",
  //   homeUrl: pageUrlGenerator("/home"),
  //   imgUrl: "/images/pragmaticplay/KoiPond.webp",
  //   alt: "Koi Pond",
  //   name: "Koi Pond",
  //   providerName: "Vivo",
  // },
  koibonanzajackpotplay: {
    href: "/casino/pragmaticplay-koi-bonanza-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/KoiBonanzaJackpotPlay.webp",
    alt: "Koi Bonanza Jackpot Play",
    name: "Koi Bonanza Jackpot Play",
    providerName: "Vivo",
  },
  kingdomofatlantisjackpotplay: {
    href: "/casino/pragmaticplay-kingdom-of-atlantis-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/KingdomofAtlantisJackpotPlay.webp",
    alt: "Kingdom of Atlantis Jackpot Play",
    name: "Kingdom of Atlantis Jackpot Play",
    providerName: "Vivo",
  },
  kingdomofasgard: {
    href: "/casino/pragmaticplay-kingdom-of-asgard",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/KingdomofAsgard.webp",
    alt: "Kingdom of Asgard",
    name: "Kingdom of Asgard",
    providerName: "Vivo",
  },
  killordie: {
    href: "/casino/pragmaticplay-kill-or-die",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/KillorDie.webp",
    alt: "Kill or Die",
    name: "Kill or Die",
    providerName: "Vivo",
  },
  jurassicgiants: {
    href: "/casino/pragmaticplay-jurassic-giants",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JurassicGiants.webp",
    alt: "Jurassic Giants",
    name: "Jurassic Giants",
    providerName: "Vivo",
  },
  junglegorilla: {
    href: "/casino/pragmaticplay-jungle-gorilla",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JungleGorilla.webp",
    alt: "Jungle Gorilla",
    name: "Jungle Gorilla",
    providerName: "Vivo",
  },
  juicyfruitsmultihold: {
    href: "/casino/pragmaticplay-juicy-fruits-multihold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JuicyFruitsMultihold.webp",
    alt: "Juicy Fruits Multihold",
    name: "Juicy Fruits Multihold",
    providerName: "Vivo",
  },
  juicyfruits: {
    href: "/casino/pragmaticplay-juicy-fruits",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JuicyFruits.webp",
    alt: "Juicy Fruits",
    name: "Juicy Fruits",
    providerName: "Vivo",
  },
  journeytothewest: {
    href: "/casino/pragmaticplay-journey-to-the-west",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JourneytotheWest.webp",
    alt: "Journey to the West",
    name: "Journey to the West",
    providerName: "Vivo",
  },
  jokersjewelstm: {
    href: "/casino/pragmaticplay-jokers-jewelstm",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JokersJewels.webp",
    alt: "Joker's Jewels™",
    name: "Joker's Jewels™",
    providerName: "Vivo",
  },
  jokersjewelswild: {
    href: "/casino/pragmaticplay-jokers-jewels-wild",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JokersJewelsWild.webp",
    alt: "Jokers Jewels Wild",
    name: "Jokers Jewels Wild",
    providerName: "Vivo",
  },
  jokersjewelshot: {
    href: "/casino/pragmaticplay-jokers-jewels-hot-u7047",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JokersJewelsHot.webp",
    alt: "Joker's Jewels Hot",
    name: "Joker's Jewels Hot",
    providerName: "Vivo",
  },
  jokersjewels: {
    href: "/casino/pragmaticplay-jokers-jewels",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JokersJewels.webp",
    alt: "Joker's Jewels",
    name: "Joker's Jewels",
    providerName: "Vivo",
  },
  jokersjewelsdice: {
    href: "/casino/pragmaticplay-jokers-jewels-dice",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JokersJewelsDice.webp",
    alt: "Joker’s Jewels Dice",
    name: "Joker’s Jewels Dice",
    providerName: "Vivo",
  },
  jokersjewelscash: {
    href: "/casino/pragmaticplay-jokers-jewels-cash",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JokersJewelsCash.webp",
    alt: "Joker’s Jewels Cash",
    name: "Joker’s Jewels Cash",
    providerName: "Vivo",
  },
  jokerrace: {
    href: "/casino/pragmaticplay-joker-race",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JokerRace.webp",
    alt: "Joker Race",
    name: "Joker Race",
    providerName: "Vivo",
  },
  jokerking: {
    href: "/casino/pragmaticplay-joker-king",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JokerKing.webp",
    alt: "Joker King",
    name: "Joker King",
    providerName: "Vivo",
  },
  jokerblastbonanza: {
    href: "/casino/pragmaticplay-joker-blast-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JokerBlastBonanza.webp",
    alt: "Joker Blast Bonanza",
    name: "Joker Blast Bonanza",
    providerName: "Vivo",
  },
  joiasdaestrela: {
    href: "/casino/pragmaticplay-joias-da-estrela",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JoiasdaEstrela.webp",
    alt: "Joias da Estrela",
    name: "Joias da Estrela",
    providerName: "Vivo",
  },
  johnhunternellanticaroma: {
    href: "/casino/pragmaticplay-john-hunter-nellantica-roma",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JohnHunterNellAnticaRoma.webp",
    alt: "John Hunter Nell’Antica Roma",
    name: "John Hunter Nell’Antica Roma",
    providerName: "Vivo",
  },
  johnhunterandthetombofthescarabqueen: {
    href: "/casino/pragmaticplay-john-hunter-and-the-tomb-of-the-scarab-queen",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/johnhunterandthetombofthescarabqueen.jpg",
    alt: "John Hunter and the Tomb of the Scarab Queen",
    name: "John Hunter and the Tomb of the Scarab Queen",
    providerName: "Vivo",
  },
  johnhunterandthequestforbermudariches: {
    href: "/casino/pragmaticplay-john-hunter-and-the-quest-for-bermuda-riches",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JohnHunterandtheQuestforBermudaRiches.webp",
    alt: "John Hunter and the Quest for Bermuda Riches",
    name: "John Hunter and the Quest for Bermuda Riches",
    providerName: "Vivo",
  },
  johnhunterandthemayangods: {
    href: "/casino/pragmaticplay-john-hunter-and-the-mayan-gods",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JohnHunterandtheMayanGods.webp",
    alt: "John Hunter and the Mayan Gods",
    name: "John Hunter and the Mayan Gods",
    providerName: "Vivo",
  },
  johnhunterandthebookoftutmegaways: {
    href: "/casino/pragmaticplay-john-hunter-and-the-book-of-tut-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JohnHunterandtheBookofTutMegaways.webp",
    alt: "John Hunter and the Book of Tut Megaways",
    name: "John Hunter and the Book of Tut Megaways",
    providerName: "Vivo",
  },
  johnhunterandthebookoftut: {
    href: "/casino/pragmaticplay-john-hunter-and-the-book-of-tut",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JohnHunterandtheBookofTut.webp",
    alt: "John Hunter and the Book of Tut",
    name: "John Hunter and the Book of Tut",
    providerName: "Vivo",
  },
  jewelrush: {
    href: "/casino/pragmaticplay-jewel-rush",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JewelRush.webp",
    alt: "Jewel Rush",
    name: "Jewel Rush",
    providerName: "Vivo",
  },
  jewelbonanza: {
    href: "/casino/pragmaticplay-jewel-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JewelBonanza.webp",
    alt: "Jewel Bonanza",
    name: "Jewel Bonanza",
    providerName: "Vivo",
  },
  jajananpasar: {
    href: "/casino/pragmaticplay-jajanan-pasar",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JajananPasar.webp",
    alt: "Jajanan Pasar",
    name: "Jajanan Pasar",
    providerName: "Vivo",
  },
  jadebutterfly: {
    href: "/casino/pragmaticplay-jade-butterfly",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JadeButterfly.webp",
    alt: "Jade Butterfly",
    name: "Jade Butterfly",
    providerName: "Vivo",
  },
  jackpothunter: {
    href: "/casino/pragmaticplay-jackpot-hunter",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/JackpotHunter.webp",
    alt: "Jackpot Hunter",
    name: "Jackpot Hunter",
    providerName: "Vivo",
  },
  irishcrown: {
    href: "/casino/pragmaticplay-irish-crown",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/IrishCrown.webp",
    alt: "Irish Crown",
    name: "Irish Crown",
    providerName: "Vivo",
  },
  infectivewild: {
    href: "/casino/pragmaticplay-infective-wild",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/InfectiveWild.webp",
    alt: "Infective Wild",
    name: "Infective Wild",
    providerName: "Vivo",
  },
  icelobster: {
    href: "/casino/pragmaticplay-ice-lobster",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/IceLobster.webp",
    alt: "Ice Lobster",
    name: "Ice Lobster",
    providerName: "Vivo",
  },
  hotfiesta: {
    href: "/casino/pragmaticplay-hotfiesta",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Hotfiesta.webp",
    alt: "Hotfiesta",
    name: "Hotfiesta",
    providerName: "Vivo",
  },
  hottoburnmultiplier: {
    href: "/casino/pragmaticplay-hot-to-burn-multiplier",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HottoBurnMultiplier.webp",
    alt: "Hot to Burn Multiplier",
    name: "Hot to Burn Multiplier",
    providerName: "Vivo",
  },
  hottoburnjackpotplay: {
    href: "/casino/pragmaticplay-hot-to-burn-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HottoBurnJackpotPlay.webp",
    alt: "Hot to Burn Jackpot Play",
    name: "Hot to Burn Jackpot Play",
    providerName: "Vivo",
  },
  hottoburnholdandspin: {
    href: "/casino/pragmaticplay-hot-to-burn-hold-and-spin",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HottoBurnHoldandSpin.webp",
    alt: "Hot to Burn Hold and Spin",
    name: "Hot to Burn Hold and Spin",
    providerName: "Vivo",
  },
  hottoburnextreme: {
    href: "/casino/pragmaticplay-hot-to-burn-extreme",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HottoBurnExtreme.webp",
    alt: "Hot to Burn Extreme",
    name: "Hot to Burn Extreme",
    providerName: "Vivo",
  },
  hottoburn7deadlyfreespins: {
    href: "/casino/pragmaticplay-hot-to-burn-7-deadly-free-spins",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HottoBurn7DeadlyFreeSpins.webp",
    alt: "Hot to Burn 7 Deadly Free Spins",
    name: "Hot to Burn 7 Deadly Free Spins",
    providerName: "Vivo",
  },
  hottoburn: {
    href: "/casino/pragmaticplay-hot-to-burn",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HottoBurn.webp",
    alt: "Hot to Burn",
    name: "Hot to Burn",
    providerName: "Vivo",
  },
  hotsafari: {
    href: "/casino/pragmaticplay-hot-safari",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HotSafari.webp",
    alt: "Hot Safari",
    name: "Hot Safari",
    providerName: "Vivo",
  },
  hotpepper: {
    href: "/casino/pragmaticplay-hot-pepper",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HotPepper.webp",
    alt: "Hot Pepper",
    name: "Hot Pepper",
    providerName: "Vivo",
  },
  hotchilli: {
    href: "/casino/pragmaticplay-hot-chilli",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HotChilli.webp",
    alt: "Hot Chilli",
    name: "Hot Chilli",
    providerName: "Vivo",
  },
  honeyhoneyhoney: {
    href: "/casino/pragmaticplay-honey-honey-honey",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HoneyHoneyHoney.webp",
    alt: "Honey Honey Honey",
    name: "Honey Honey Honey",
    providerName: "Vivo",
  },
  holidayride: {
    href: "/casino/pragmaticplay-holiday-ride",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HolidayRide.webp",
    alt: "Holiday Ride",
    name: "Holiday Ride",
    providerName: "Vivo",
  },
  hokkaidowolf: {
    href: "/casino/pragmaticplay-hokkaido-wolf",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HokkaidoWolf.webp",
    alt: "Hokkaido Wolf",
    name: "Hokkaido Wolf",
    providerName: "Vivo",
  },
  hockeyleaguewildmatch: {
    href: "/casino/pragmaticplay-hockey-league-wild-match",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HockeyLeagueWildMatch.webp",
    alt: "Hockey League Wild Match",
    name: "Hockey League Wild Match",
    providerName: "Vivo",
  },
  wavemaster: {
    href: "/casino/pragmaticplay-wave-master",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/WaveMaster.webp",
    alt: "Wave Master",
    name: "Wave Master",
    providerName: "Vivo",
  },
  vulkanofolympus: {
    href: "/casino/pragmaticplay-vulkan-of-olympus",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/vulkanofolympus.webp",
    alt: "Vulkan of Olympus",
    name: "Vulkan of Olympus",
    providerName: "Vivo",
  },
  voodoomagic: {
    href: "/casino/pragmaticplay-voodoo-magic",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/VoodooMagic.webp",
    alt: "Voodoo Magic",
    name: "Voodoo Magic",
    providerName: "Vivo",
  },
  vikingsvstrolls: {
    href: "/casino/pragmaticplay-vikings-vs-trolls",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/VikingsvsTrolls.webp",
    alt: "Vikings vs Trolls",
    name: "Vikings vs Trolls",
    providerName: "Vivo",
  },
  vikingforge: {
    href: "/casino/pragmaticplay-viking-forge",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/VikingForge.webp",
    alt: "Viking Forge",
    name: "Viking Forge",
    providerName: "Vivo",
  },
  viadelcorso: {
    href: "/casino/pragmaticplay-via-del-corso",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ViadelCorso.webp",
    alt: "Via del Corso",
    name: "Via del Corso",
    providerName: "Vivo",
  },
  vegasnights: {
    href: "/casino/pragmaticplay-vegas-nights",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/VegasNights.webp",
    alt: "Vegas Nights",
    name: "Vegas Nights",
    providerName: "Vivo",
  },
  vegasadventures: {
    href: "/casino/pragmaticplay-vegas-adventures",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/VegasAdventures.webp",
    alt: "Vegas Adventures",
    name: "Vegas Adventures",
    providerName: "Vivo",
  },
  vampiresvswolves: {
    href: "/casino/pragmaticplay-vampires-vs-wolves",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/VampiresvsWolves.webp",
    alt: "Vampires vs Wolves",
    name: "Vampires vs Wolves",
    providerName: "Vivo",
  },
  ultraholdandspin: {
    href: "/casino/pragmaticplay-ultra-hold-and-spin",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/UltraHoldandSpin.webp",
    alt: "Ultra Hold and Spin",
    name: "Ultra Hold and Spin",
    providerName: "Vivo",
  },
  ultraburn: {
    href: "/casino/pragmaticplay-ultra-burn",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/UltraBurn.webp",
    alt: "Ultra Burn",
    name: "Ultra Burn",
    providerName: "Vivo",
  },
  twilightprincess: {
    href: "/casino/pragmaticplay-twilight-princess",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TwilightPrincess.webp",
    alt: "Twilight Princess",
    name: "Twilight Princess",
    providerName: "Vivo",
  },
  tundrasfortune: {
    href: "/casino/pragmaticplay-tundras-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TundrasFortune.webp",
    alt: "Tundras Fortune",
    name: "Tundras Fortune",
    providerName: "Vivo",
  },
  tucanito: {
    href: "/casino/pragmaticplay-tucanito",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Tucanito.webp",
    alt: "Tucanito",
    name: "Tucanito",
    providerName: "Vivo",
  },
  tsilidoghouse: {
    href: "/casino/pragmaticplay-tsili-dog-house",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TSILIDogHouse.webp",
    alt: "TSILI Dog House",
    name: "TSILI Dog House",
    providerName: "Vivo",
  },
  tropicaltiki: {
    href: "/casino/pragmaticplay-tropical-tiki",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TropicalTiki.webp",
    alt: "Tropical Tiki",
    name: "Tropical Tiki",
    providerName: "Vivo",
  },
  tropicalpopjackpotplay: {
    href: "/casino/pragmaticplay-tropical-pop-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TropicalPopJackpotPlay.webp",
    alt: "Tropical Pop Jackpot Play",
    name: "Tropical Pop Jackpot Play",
    providerName: "Vivo",
  },
  trolling1000: {
    href: "/casino/pragmaticplay-trolling-1000",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Trolling1000.webp",
    alt: "Trolling 1000",
    name: "Trolling 1000",
    providerName: "Vivo",
  },
  tripletigers: {
    href: "/casino/pragmaticplay-triple-tigers",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TripleTigers.webp",
    alt: "Triple Tigers",
    name: "Triple Tigers",
    providerName: "Vivo",
  },
  triplepotgold: {
    href: "/casino/pragmaticplay-triple-pot-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TriplePotGold.webp",
    alt: "Triple Pot Gold",
    name: "Triple Pot Gold",
    providerName: "Vivo",
  },
  triplejokers: {
    href: "/casino/pragmaticplay-triple-jokers",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TripleJokers.webp",
    alt: "Triple Jokers",
    name: "Triple Jokers",
    providerName: "Vivo",
  },
  tripledragons: {
    href: "/casino/pragmaticplay-triple-dragons",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TripleDragons.webp",
    alt: "Triple Dragons",
    name: "Triple Dragons",
    providerName: "Vivo",
  },
  treesoftreasure: {
    href: "/casino/pragmaticplay-trees-of-treasure",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TreesofTreasure.webp",
    alt: "Trees of Treasure",
    name: "Trees of Treasure",
    providerName: "Vivo",
  },
  treeofriches: {
    href: "/casino/pragmaticplay-tree-of-riches",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TreeofRiches.webp",
    alt: "Tree of Riches",
    name: "Tree of Riches",
    providerName: "Vivo",
  },
  treasurewild: {
    href: "/casino/pragmaticplay-treasure-wild",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TreasureWild.webp",
    alt: "Treasure Wild",
    name: "Treasure Wild",
    providerName: "Vivo",
  },
  treasuretrawler: {
    href: "/casino/pragmaticplay-treasure-trawler",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TreasureTrawler.webp",
    alt: "Treasure Trawler",
    name: "Treasure Trawler",
    providerName: "Vivo",
  },
  treasurehorse: {
    href: "/casino/pragmaticplay-treasure-horse",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TreasureHors.webp",
    alt: "Treasure Horse",
    name: "Treasure Horse",
    providerName: "Vivo",
  },
  traintoseoul: {
    href: "/casino/pragmaticplay-train-to-seoul",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TraintoSeoul.webp",
    alt: "Train to Seoul",
    name: "Train to Seoul",
    providerName: "Vivo",
  },
  tinytoads: {
    href: "/casino/pragmaticplay-tiny-toads",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TinyToads.webp",
    alt: "Tiny Toads",
    name: "Tiny Toads",
    providerName: "Vivo",
  },
  tigresortudo: {
    href: "/casino/pragmaticplay-tigre-sortudo",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TigreSortudo.webp",
    alt: "Tigre Sortudo",
    name: "Tigre Sortudo",
    providerName: "Vivo",
  },
  tictactake: {
    href: "/casino/pragmaticplay-tic-tac-take",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TicTacTake.webp",
    alt: "Tic Tac Take",
    name: "Tic Tac Take",
    providerName: "Vivo",
  },
  thundervsunderworld: {
    href: "/casino/pragmaticplay-thunder-vs-underworld",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ThundervsUnderworld.webp",
    alt: "Thunder vs Underworld",
    name: "Thunder vs Underworld",
    providerName: "Vivo",
  },
  threestarfortune: {
    href: "/casino/pragmaticplay-three-star-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ThreeStarFortune.webp",
    alt: "Three Star Fortune",
    name: "Three Star Fortune",
    providerName: "Vivo",
  },
  thewildgang: {
    href: "/casino/pragmaticplay-the-wild-gang",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheWildGang.webp",
    alt: "The Wild Gang",
    name: "The Wild Gang",
    providerName: "Vivo",
  },
  theultimate5: {
    href: "/casino/pragmaticplay-the-ultimate-5",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheUltimate5.webp",
    alt: "The Ultimate 5",
    name: "The Ultimate 5",
    providerName: "Vivo",
  },
  thetweetyhouse: {
    href: "/casino/pragmaticplay-the-tweety-house",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheTweetyHouse.webp",
    alt: "The Tweety House",
    name: "The Tweety House",
    providerName: "Vivo",
  },
  thetigerwarrior: {
    href: "/casino/pragmaticplay-the-tiger-warrior",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheTigerWarrior.webp",
    alt: "The Tiger Warrior",
    name: "The Tiger Warrior",
    providerName: "Vivo",
  },
  theroohouse: {
    href: "/casino/pragmaticplay-the-roo-house",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheRooHouse.webp",
    alt: "The Roo House",
    name: "The Roo House",
    providerName: "Vivo",
  },
  themoneymenmegaways: {
    href: "/casino/pragmaticplay-the-money-men-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheMoneyMenMegaways.webp",
    alt: "The Money Men Megaways",
    name: "The Money Men Megaways",
    providerName: "Vivo",
  },
  themagiccauldronenchantedbrew: {
    href: "/casino/pragmaticplay-the-magic-cauldron-enchanted-brew",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheMagicCauldronEnchantedBrew.webp",
    alt: "The Magic Cauldron  Enchanted Brew",
    name: "The Magic Cauldron  Enchanted Brew",
    providerName: "Vivo",
  },
  thehandofmidas: {
    href: "/casino/pragmaticplay-the-hand-of-midas",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheHandofMidas.webp",
    alt: "The Hand of Midas",
    name: "The Hand of Midas",
    providerName: "Vivo",
  },
  thegreensun: {
    href: "/casino/pragmaticplay-the-green-sun",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheGreenSun.webp",
    alt: "The Green Sun",
    name: "The Green Sun",
    providerName: "Vivo",
  },
  thegreatstickup: {
    href: "/casino/pragmaticplay-the-great-stick-up",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheGreatStickUp.webp",
    alt: "The Great Stick-Up",
    name: "The Great Stick-Up",
    providerName: "Vivo",
  },
  thegreatchickenescape: {
    href: "/casino/pragmaticplay-the-great-chicken-escape",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheGreatChickenEscape.webp",
    alt: "The Great Chicken Escape",
    name: "The Great Chicken Escape",
    providerName: "Vivo",
  },
  thedragontiger: {
    href: "/casino/pragmaticplay-the-dragon-tiger",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheDragonTiger.webp",
    alt: "The Dragon Tiger",
    name: "The Dragon Tiger",
    providerName: "Vivo",
  },
  thedoghousemultihold: {
    href: "/casino/pragmaticplay-the-dog-house-multihold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheDogHouseMultihold.webp",
    alt: "The Dog House Multihold",
    name: "The Dog House Multihold",
    providerName: "Vivo",
  },
  thedoghousemegaways: {
    href: "/casino/pragmaticplay-the-dog-house-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheDogHouseMegaways.webp",
    alt: "The Dog House Megaways",
    name: "The Dog House Megaways",
    providerName: "Vivo",
  },
  thedoghousediceshow: {
    href: "/casino/pragmaticplay-the-dog-house-dice-show",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheDogHouseDiceShow.webp",
    alt: "The Dog House Dice Show",
    name: "The Dog House Dice Show",
    providerName: "Vivo",
  },
  thedoghouseroyalhunt: {
    href: "/casino/pragmaticplay-the-dog-house-royal-hunt",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheDogHouseRoyalHunt.webp",
    alt: "The Dog House – Royal Hunt",
    name: "The Dog House – Royal Hunt",
    providerName: "Vivo",
  },
  thedoghousemuttleycrew: {
    href: "/casino/pragmaticplay-the-dog-house-muttley-crew",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheDogHouseMuttleyCrew.webp",
    alt: "The Dog House - Muttley Crew",
    name: "The Dog House - Muttley Crew",
    providerName: "Vivo",
  },
  thedoghousedogoralive: {
    href: "/casino/pragmaticplay-the-dog-house-dog-or-alive",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheDogHouseDogorAlive.webp",
    alt: "The Dog House - Dog or Alive",
    name: "The Dog House - Dog or Alive",
    providerName: "Vivo",
  },

  thecatfatherpartii: {
    href: "/casino/pragmaticplay-the-catfather-part-ii",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheCatfatherPartII.webp",
    alt: "The Catfather Part II",
    name: "The Catfather Part II",
    providerName: "Vivo",
  },
  thecatfather: {
    href: "/casino/pragmaticplay-the-catfather",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheCatfather.webp",
    alt: "The Catfather",
    name: "The Catfather",
    providerName: "Vivo",
  },
  thebirdhouse: {
    href: "/casino/pragmaticplay-the-bird-house",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheBirdHouse.webp",
    alt: "The Bird House",
    name: "The Bird House",
    providerName: "Vivo",
  },
  thebigdawgs: {
    href: "/casino/pragmaticplay-the-big-dawgs",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheBigDawgs.webp",
    alt: "The Big Dawgs",
    name: "The Big Dawgs",
    providerName: "Vivo",
  },
  theamazingmoneymachine: {
    href: "/casino/pragmaticplay-the-amazing-money-machine",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheAmazingMoneyMachine.webp",
    alt: "The Amazing Money Machine",
    name: "The Amazing Money Machine",
    providerName: "Vivo",
  },
  thealterego: {
    href: "/casino/pragmaticplay-the-alter-ego",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TheAlterEgo.webp",
    alt: "The Alter Ego",
    name: "The Alter Ego",
    providerName: "Vivo",
  },
  temujintreasures: {
    href: "/casino/pragmaticplay-temujin-treasures",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TemujinTreasures.webp",
    alt: "Temujin Treasures",
    name: "Temujin Treasures",
    providerName: "Vivo",
  },
  templeguardians: {
    href: "/casino/pragmaticplay-temple-guardians",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TempleGuardians.webp",
    alt: "Temple Guardians",
    name: "Temple Guardians",
    providerName: "Vivo",
  },
  talesofegypt: {
    href: "/casino/pragmaticplay-tales-of-egypt",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/TalesofEgypt.webp",
    alt: "Tales of Egypt",
    name: "Tales of Egypt",
    providerName: "Vivo",
  },
  swordofares: {
    href: "/casino/pragmaticplay-sword-of-ares",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SwordofAres.webp",
    alt: "Sword of Ares",
    name: "Sword of Ares",
    providerName: "Vivo",
  },
  sweetpowernudge: {
    href: "/casino/pragmaticplay-sweet-powernudge",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SweetPowerNudge.webp",
    alt: "Sweet PowerNudge",
    name: "Sweet PowerNudge",
    providerName: "Vivo",
  },
  firebirdspirit: {
    href: "/casino/pragmaticplay-firebird-spirit",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FirebirdSpirit.webp",
    alt: "Firebird Spirit",
    name: "Firebird Spirit",
    providerName: "Vivo",
  },
  sweetkingdom: {
    href: "/casino/pragmaticplay-sweet-kingdom",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SweetKingdom.webp",
    alt: "Sweet Kingdom",
    name: "Sweet Kingdom",
    providerName: "Vivo",
  },
  sweetfiesta: {
    href: "/casino/pragmaticplay-sweet-fiesta",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SweetFiesta.webp",
    alt: "Sweet Fiesta",
    name: "Sweet Fiesta",
    providerName: "Vivo",
  },
  sweetbonanzaxmas: {
    href: "/casino/pragmaticplay-sweet-bonanza-xmas",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SweetBonanzaXmas.webp",
    alt: "Sweet Bonanza Xmas",
    name: "Sweet Bonanza Xmas",
    providerName: "Vivo",
  },
  sweetbonanzasuperscatter: {
    href: "/casino/pragmaticplay-sweet-bonanza-super-scatter",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SweetBonanzaSuperScatter.webp",
    alt: "Sweet Bonanza Super Scatter",
    name: "Sweet Bonanza Super Scatter",
    providerName: "Vivo",
  },
  sweetbonanzadice: {
    href: "/casino/pragmaticplay-sweet-bonanza-dice",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SweetBonanza.webp",
    alt: "Sweet Bonanza Dice",
    name: "Sweet Bonanza Dice",
    providerName: "Vivo",
  },
  sweetbonanzadice: {
    href: "/casino/pragmaticplay-sweet-bonanza-1000-dice",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SweetBonanza1000Dice.webp",
    alt: "Sweet Bonanza 1000 Dice",
    name: "Sweet Bonanza 1000 Dice",
    providerName: "Vivo",
  },
  sweetbonanza1000: {
    href: "/casino/pragmaticplay-sweet-bonanza-1000",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SweetBonanza1000.webp",
    alt: "Sweet Bonanza 1000",
    name: "Sweet Bonanza 1000",
    providerName: "Vivo",
  },

  sweetbombdrop: {
    href: "/casino/pragmaticplay-sweet-bomb-drop",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SweetBombDrop.webp",
    alt: "Sweet Bomb Drop",
    name: "Sweet Bomb Drop",
    providerName: "Vivo",
  },
  sweetbaklava: {
    href: "/casino/pragmaticplay-sweet-baklava",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SweetBaklava.webp",
    alt: "Sweet Baklava",
    name: "Sweet Baklava",
    providerName: "Vivo",
  },
  supermania: {
    href: "/casino/pragmaticplay-supermania",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Supermania.webp",
    alt: "Supermania",
    name: "Supermania",
    providerName: "Vivo",
  },
  superligaheroes: {
    href: "/casino/pragmaticplay-superliga-heroes",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SuperligaHeroes.webp",
    alt: "Superliga Heroes",
    name: "Superliga Heroes",
    providerName: "Vivo",
  },
  superx: {
    href: "/casino/pragmaticplay-super-x",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SuperX.webp",
    alt: "Super X",
    name: "Super X",
    providerName: "Vivo",
  },
  superjoker: {
    href: "/casino/pragmaticplay-super-joker",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SuperJoker.webp",
    alt: "Super Joker",
    name: "Super Joker",
    providerName: "Vivo",
  },
  super7s: {
    href: "/casino/pragmaticplay-super-7s",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Super7s.webp",
    alt: "Super 7s",
    name: "Super 7s",
    providerName: "Vivo",
  },
  sunstonejewels: {
    href: "/casino/pragmaticplay-sunstone-jewels",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SunstoneJewels.webp",
    alt: "Sunstone Jewels",
    name: "Sunstone Jewels",
    providerName: "Vivo",
  },
  sumosuprememegaways: {
    href: "/casino/pragmaticplay-sumo-supreme-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SumoSupremeMegaways.webp",
    alt: "Sumo Supreme Megaways",
    name: "Sumo Supreme Megaways",
    providerName: "Vivo",
  },
  sugartwist: {
    href: "/casino/pragmaticplay-sugar-twist",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SugarTwist.webp",
    alt: "Sugar Twist",
    name: "Sugar Twist",
    providerName: "Vivo",
  },
  sugarsupremepowernudge: {
    href: "/casino/pragmaticplay-sugar-supreme-powernudge",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SugarSupremePowernudge.webp",
    alt: "Sugar Supreme Powernudge",
    name: "Sugar Supreme Powernudge",
    providerName: "Vivo",
  },
  sugarrushxmas: {
    href: "/casino/pragmaticplay-sugar-rush-xmas",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SugarRushXmas.webp",
    alt: "Sugar Rush Xmas",
    name: "Sugar Rush Xmas",
    providerName: "Vivo",
  },
  sugarrushdice: {
    href: "/casino/pragmaticplay-sugar-rush-dice",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SugarRushDice.webp",
    alt: "Sugar Rush Dice",
    name: "Sugar Rush Dice",
    providerName: "Vivo",
  },
  sugarrush1000: {
    href: "/casino/pragmaticplay-sugar-rush-1000",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SugarRush1000.webp",
    alt: "Sugar Rush 1000",
    name: "Sugar Rush 1000",
    providerName: "Vivo",
  },

  strikinghot5jackpotplay: {
    href: "/casino/pragmaticplay-striking-hot-5-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/StrikingHot5JackpotPlay.webp",
    alt: "Striking Hot 5 Jackpot Play",
    name: "Striking Hot 5 Jackpot Play",
    providerName: "Vivo",
  },

  strikefrenzy: {
    href: "/casino/pragmaticplay-strike-frenzy",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/StrikeFrenzy.webp",
    alt: "Strike Frenzy",
    name: "Strike Frenzy",
    providerName: "Vivo",
  },
  streetracer: {
    href: "/casino/pragmaticplay-street-racer",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/StreetRacer.webp",
    alt: "Street Racer",
    name: "Street Racer",
    providerName: "Vivo",
  },
  strawberrycocktail: {
    href: "/casino/pragmaticplay-strawberry-cocktail",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/StrawberryCocktail.webp",
    alt: "Strawberry Cocktail",
    name: "Strawberry Cocktail",
    providerName: "Vivo",
  },
  stickybees: {
    href: "/casino/pragmaticplay-sticky-bees",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/StickyBees.webp",
    alt: "Sticky Bees",
    name: "Sticky Bees",
    providerName: "Vivo",
  },
  starzmegaways: {
    href: "/casino/pragmaticplay-starz-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/StarzMegaways.webp",
    alt: "Starz Megaways",
    name: "Starz Megaways",
    providerName: "Vivo",
  },
  starlightprincesspachi: {
    href: "/casino/pragmaticplay-starlight-princess-pachi",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/StarlightPrincessPachi.webp",
    alt: "Starlight Princess Pachi",
    name: "Starlight Princess Pachi",
    providerName: "Vivo",
  },
  starlightprincess1000: {
    href: "/casino/pragmaticplay-starlight-princess-1000",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/StarlightPrincess1000.webp",
    alt: "Starlight Princess 1000",
    name: "Starlight Princess 1000",
    providerName: "Vivo",
  },
  starlightprincess: {
    href: "/casino/pragmaticplay-starlight-princess",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/StarlightPrincess.webp",
    alt: "Starlight Princess",
    name: "Starlight Princess",
    providerName: "Vivo",
  },
  starlightchristmas: {
    href: "/casino/pragmaticplay-starlight-christmas",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/StarlightChristmas.webp",
    alt: "Starlight Christmas",
    name: "Starlight Christmas",
    providerName: "Vivo",
  },
  starpiratescode: {
    href: "/casino/pragmaticplay-star-pirates-code",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/StarPiratesCode.webp",
    alt: "Star Pirates Code",
    name: "Star Pirates Code",
    providerName: "Vivo",
  },
  starbounty: {
    href: "/casino/pragmaticplay-star-bounty",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/StarBounty.webp",
    alt: "Star Bounty",
    name: "Star Bounty",
    providerName: "Vivo",
  },
  spinscoremegaways: {
    href: "/casino/pragmaticplay-spin-and-score-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Spin&ScoreMegaways.webp",
    alt: "Spin & Score Megaways",
    name: "Spin & Score Megaways",
    providerName: "Vivo",
  },
  spellbindingmystery: {
    href: "/casino/pragmaticplay-spellbinding-mystery",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SpellbindingMystery.webp",
    alt: "Spellbinding Mystery",
    name: "Spellbinding Mystery",
    providerName: "Vivo",
  },
  spartanking: {
    href: "/casino/pragmaticplay-spartan-king",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SpartanKing.webp",
    alt: "Spartan King",
    name: "Spartan King",
    providerName: "Vivo",
  },
  snakesandladdersmegadice: {
    href: "/casino/pragmaticplay-snakes-and-ladders-megadice",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SnakesandLaddersMegadice.webp",
    alt: "Snakes and Ladders Megadice",
    name: "Snakes and Ladders Megadice",
    providerName: "Vivo",
  },
  snakesladderssnakeeyes: {
    href: "/casino/pragmaticplay-snakes-and-ladders-snake-eyes",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Snakes&LaddersSnakeEyes.webp",
    alt: "Snakes & Ladders - Snake Eyes",
    name: "Snakes & Ladders - Snake Eyes",
    providerName: "Vivo",
  },
  smugglerscove: {
    href: "/casino/pragmaticplay-smugglers-cove",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SmugglersCove.webp",
    alt: "Smugglers Cove",
    name: "Smugglers Cove",
    providerName: "Vivo",
  },
  slushieparty: {
    href: "/casino/pragmaticplay-slushie-party",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SlushieParty.webp",
    alt: "Slushie Party",
    name: "Slushie Party",
    providerName: "Vivo",
  },
  slotmaniarabbit: {
    href: "/casino/pragmaticplay-slot-mania-rabbit",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SlotManiaRabbit.webp",
    alt: "Slot Mania Rabbit",
    name: "Slot Mania Rabbit",
    providerName: "Vivo",
  },
  sleepingdragon: {
    href: "/casino/pragmaticplay-sleeping-dragon",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SleepingDragon.webp",
    alt: "Sleeping Dragon",
    name: "Sleeping Dragon",
    providerName: "Vivo",
  },
  skybounty: {
    href: "/casino/pragmaticplay-sky-bounty",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SkyBounty.webp",
    alt: "Sky Bounty",
    name: "Sky Bounty",
    providerName: "Vivo",
  },
  shotsforslots: {
    href: "/casino/pragmaticplay-shots-for-slots",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/shotsforslots.webp",
    alt: "Shots for Slots",
    name: "Shots for Slots",
    providerName: "Vivo",
  },
  shininghot5jackpotplay: {
    href: "/casino/pragmaticplay-shining-hot-5-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ShiningHot5JackpotPlay.webp",
    alt: "Shining Hot 5 Jackpot Play",
    name: "Shining Hot 5 Jackpot Play",
    providerName: "Vivo",
  },
  shininghot5: {
    href: "/casino/pragmaticplay-shining-hot-5",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ShiningHot5.webp",
    alt: "Shining Hot 5",
    name: "Shining Hot 5",
    providerName: "Vivo",
  },
  shininghot40jackpotplay: {
    href: "/casino/pragmaticplay-shining-hot-40-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ShiningHot40JackpotPlay.webp",
    alt: "Shining Hot 40 Jackpot Play",
    name: "Shining Hot 40 Jackpot Play",
    providerName: "Vivo",
  },
  shininghot40: {
    href: "/casino/pragmaticplay-shining-hot-40",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ShiningHot40.webp",
    alt: "Shining Hot 40",
    name: "Shining Hot 40",
    providerName: "Vivo",
  },
  shininghot20jackpotplay: {
    href: "/casino/pragmaticplay-shining-hot-20-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ShiningHot20Jackpotplay.webp",
    alt: "Shining Hot 20 Jackpot play",
    name: "Shining Hot 20 Jackpot play",
    providerName: "Vivo",
  },
  shininghot20: {
    href: "/casino/pragmaticplay-shining-hot-20",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ShiningHot20.webp",
    alt: "Shining Hot 20",
    name: "Shining Hot 20",
    providerName: "Vivo",
  },
  shininghot100jackpotplay: {
    href: "/casino/pragmaticplay-shining-hot-100-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ShiningHot100JackpotPlay.webp",
    alt: "Shining Hot 100 Jackpot Play",
    name: "Shining Hot 100 Jackpot Play",
    providerName: "Vivo",
  },
  shininghot100: {
    href: "/casino/pragmaticplay-shining-hot-100",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ShiningHot100.webp",
    alt: "Shining Hot 100",
    name: "Shining Hot 100",
    providerName: "Vivo",
  },
  shieldofsparta: {
    href: "/casino/pragmaticplay-shield-of-sparta",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ShieldofSparta.webp",
    alt: "Shield of Sparta",
    name: "Shield of Sparta",
    providerName: "Vivo",
  },
  savannahlegend: {
    href: "/casino/pragmaticplay-savannah-legend",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SavannahLegend.webp",
    alt: "Savannah Legend",
    name: "Savannah Legend",
    providerName: "Vivo",
  },
  sasuntsidavit: {
    href: "/casino/pragmaticplay-sasuntsi-davit",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SasuntsiDavit.webp",
    alt: "Sasuntsi Davit",
    name: "Sasuntsi Davit",
    providerName: "Vivo",
  },
  sarayruyasi: {
    href: "/casino/pragmaticplay-saray-ruyasi",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SarayRuyasi.webp",
    alt: "Saray Ruyasi",
    name: "Saray Ruyasi",
    providerName: "Vivo",
  },
  santasxmasrush: {
    href: "/casino/pragmaticplay-santas-xmas-rush",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SantasXmasRush.webp",
    alt: "Santas Xmas Rush",
    name: "Santas Xmas Rush",
    providerName: "Vivo",
  },
  SeaFantasy: {
    href: "/casino/pragmaticplay-sea-fantasy",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SeaFantasy.webp",
    alt: "Sea Fantasy",
    name: "Sea Fantasy",
    providerName: "Vivo",
  },
  santaswonderland: {
    href: "/casino/pragmaticplay-santas-wonderland",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SantasWonderland.webp",
    alt: "Santas Wonderland",
    name: "Santas Wonderland",
    providerName: "Vivo",
  },
  santasgreatgifts: {
    href: "/casino/pragmaticplay-santas-great-gifts",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SantasGreatGifts.webp",
    alt: "Santa’s Great Gifts",
    name: "Santa’s Great Gifts",
    providerName: "Vivo",
  },
  santa: {
    href: "/casino/pragmaticplay-santa",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Santa.webp",
    alt: "Santa",
    name: "Santa",
    providerName: "Vivo",
  },
  samuraicode: {
    href: "/casino/pragmaticplay-samurai-code",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SamuraiCode.webp",
    alt: "Samurai Code",
    name: "Samurai Code",
    providerName: "Vivo",
  },
  saiyanmania: {
    href: "/casino/pragmaticplay-saiyan-mania",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SaiyanMania.webp",
    alt: "Saiyan Mania",
    name: "Saiyan Mania",
    providerName: "Vivo",
  },
  safariking: {
    href: "/casino/pragmaticplay-safari-king",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SafariKing.webp",
    alt: "Safari King",
    name: "Safari King",
    providerName: "Vivo",
  },
  sabafufufu: {
    href: "/casino/pragmaticplay-saba-fu-fu-fu",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/SabaFuFuFu.webp",
    alt: "Saba Fu Fu Fu",
    name: "Saba Fu Fu Fu",
    providerName: "Vivo",
  },
  runningsushi: {
    href: "/casino/pragmaticplay-running-sushi",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/RunningSushi.webp",
    alt: "Running Sushi",
    name: "Running Sushi",
    providerName: "Vivo",
  },
  runaway7s: {
    href: "/casino/pragmaticplay-runaway-7s",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Runaway7s.webp",
    alt: "Runaway 7s",
    name: "Runaway 7s",
    providerName: "Vivo",
  },
  rujakbonanza: {
    href: "/casino/pragmaticplay-rujak-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/RujakBonanza.webp",
    alt: "Rujak Bonanza",
    name: "Rujak Bonanza",
    providerName: "Vivo",
  },
  romeoandjuliet: {
    href: "/casino/pragmaticplay-romeo-and-juliet",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/RomeoandJuliet.webp",
    alt: "Romeo and Juliet",
    name: "Romeo and Juliet",
    providerName: "Vivo",
  },
  rockvegasmegaholdspin: {
    href: "/casino/pragmaticplay-rock-vegas-mega-hold-and-spin",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/RockVegasMegaHold&Spin.webp",
    alt: "Rock Vegas Mega Hold & Spin",
    name: "Rock Vegas Mega Hold & Spin",
    providerName: "Vivo",
  },
  robberstrike: {
    href: "/casino/pragmaticplay-robber-strike",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/RobberStrike.webp",
    alt: "Robber Strike",
    name: "Robber Strike",
    providerName: "Vivo",
  },
  riverofstyx: {
    href: "/casino/pragmaticplay-river-of-styx",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/RiverofStyx.webp",
    alt: "River of Styx",
    name: "River of Styx",
    providerName: "Vivo",
  },
  riseofsamuraimegaways: {
    href: "/casino/pragmaticplay-rise-of-samurai-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/RiseofSamuraiMegaways.webp",
    alt: "Rise of Samurai Megaways",
    name: "Rise of Samurai Megaways",
    providerName: "Vivo",
  },
  riseofsamurai4: {
    href: "/casino/pragmaticplay-rise-of-samurai-4",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/RiseofSamurai4.webp",
    alt: "Rise of Samurai 4",
    name: "Rise of Samurai 4",
    providerName: "Vivo",
  },
  riseofsamurai3: {
    href: "/casino/pragmaticplay-rise-of-samurai-3",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/RiseofSamurai3.webp",
    alt: "Rise of Samurai 3",
    name: "Rise of Samurai 3",
    providerName: "Vivo",
  },
  riseofsamurai: {
    href: "/casino/pragmaticplay-rise-of-samurai",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/RiseofSamurai.webp",
    alt: "Rise of Samurai",
    name: "Rise of Samurai",
    providerName: "Vivo",
  },
  riseofpyramids: {
    href: "/casino/pragmaticplay-rise-of-pyramids",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/RiseofPyramids.webp",
    alt: "Rise of Pyramids",
    name: "Rise of Pyramids",
    providerName: "Vivo",
  },
  riseofgizapowernudge: {
    href: "/casino/pragmaticplay-rise-of-giza-powernudge",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/RiseofGizaPowerNudge.webp",
    alt: "Rise of Giza PowerNudge",
    name: "Rise of Giza PowerNudge",
    providerName: "Vivo",
  },
  riperewards: {
    href: "/casino/pragmaticplay-ripe-rewards",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/RipeRewards.webp",
    alt: "Ripe Rewards",
    name: "Ripe Rewards",
    providerName: "Vivo",
  },
  ridethelightning: {
    href: "/casino/pragmaticplay-ride-the-lightning",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/RideTheLightning.webp",
    alt: "Ride The Lightning",
    name: "Ride The Lightning",
    providerName: "Vivo",
  },
  revengeoflokimegaways: {
    href: "/casino/pragmaticplay-revenge-of-loki-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/RevengeofLokiMegaways.webp",
    alt: "Revenge of Loki Megaways",
    name: "Revenge of Loki Megaways",
    providerName: "Vivo",
  },
  returnofthedead: {
    href: "/casino/pragmaticplay-return-of-the-dead",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ReturnoftheDead.webp",
    alt: "Return of the Dead",
    name: "Return of the Dead",
    providerName: "Vivo",
  },
  resurrectingriches: {
    href: "/casino/pragmaticplay-resurrecting-riches",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ResurrectingRiches.webp",
    alt: "Resurrecting Riches",
    name: "Resurrecting Riches",
    providerName: "Vivo",
  },
  releasethekraken: {
    href: "/casino/pragmaticplay-release-the-kraken",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ReleasetheKraken.webp",
    alt: "Release the Kraken",
    name: "Release the Kraken",
    providerName: "Vivo",
  },
  releasethebison: {
    href: "/casino/pragmaticplay-release-the-bison",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ReleasetheBison.webp",
    alt: "Release the Bison",
    name: "Release the Bison",
    providerName: "Vivo",
  },
  reelbanks: {
    href: "/casino/pragmaticplay-reel-banks",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ReelBanks.webp",
    alt: "Reel Banks",
    name: "Reel Banks",
    providerName: "Vivo",
  },
  redhotluck: {
    href: "/casino/pragmaticplay-red-hot-luck",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/RedHotLuck.webp",
    alt: "Red Hot Luck",
    name: "Red Hot Luck",
    providerName: "Vivo",
  },
  rainbowreels: {
    href: "/casino/pragmaticplay-rainbow-reels",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/RainbowReels.webp",
    alt: "Rainbow Reels",
    name: "Rainbow Reels",
    providerName: "Vivo",
  },
  rainbowgold: {
    href: "/casino/pragmaticplay-rainbow-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/RainbowGold.webp",
    alt: "Rainbow Gold",
    name: "Rainbow Gold",
    providerName: "Vivo",
  },
  ragingwaterfallmegaways: {
    href: "/casino/pragmaticplay-raging-waterfall-megawaystm",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/RagingWaterfallMegaways.webp",
    alt: "Raging Waterfall Megaways™",
    name: "Raging Waterfall Megaways™",
    providerName: "Vivo",
  },
  ragingbull: {
    href: "/casino/pragmaticplay-raging-bull",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/RagingBull.webp",
    alt: "Raging Bull",
    name: "Raging Bull",
    providerName: "Vivo",
  },
  racingjoker: {
    href: "/casino/pragmaticplay-racing-joker",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/RacingJoker.webp",
    alt: "Racing Joker",
    name: "Racing Joker",
    providerName: "Vivo",
  },
  rabbitgarden: {
    href: "/casino/pragmaticplay-rabbit-garden",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/RabbitGarden.webp",
    alt: "Rabbit Garden",
    name: "Rabbit Garden",
    providerName: "Vivo",
  },
  queenie: {
    href: "/casino/pragmaticplay-queenie",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Queenie.webp",
    alt: "Queenie",
    name: "Queenie",
    providerName: "Vivo",
  },
  queenofgold: {
    href: "/casino/pragmaticplay-queen-of-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/QueenofGold.webp",
    alt: "Queen of Gold",
    name: "Queen of Gold",
    providerName: "Vivo",
  },
  queenofgods: {
    href: "/casino/pragmaticplay-queen-of-gods",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/QueenofGods.webp",
    alt: "Queen of Gods",
    name: "Queen of Gods",
    providerName: "Vivo",
  },
  pyramidking: {
    href: "/casino/pragmaticplay-pyramid-king",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PyramidKing.webp",
    alt: "Pyramid King",
    name: "Pyramid King",
    providerName: "Vivo",
  },
  pyramidbonanza: {
    href: "/casino/pragmaticplay-pyramid-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PyramidBonanza.webp",
    alt: "Pyramid Bonanza",
    name: "Pyramid Bonanza",
    providerName: "Vivo",
  },
  puresweet: {
    href: "/casino/pragmaticplay-pure-sweet",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/puresweet.webp",
    alt: "Pure Sweet",
    name: "Pure Sweet",
    providerName: "Vivo",
  },
  purefruit: {
    href: "/casino/pragmaticplay-pure-fruit",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PureFruit.webp",
    alt: "Pure Fruit",
    name: "Pure Fruit",
    providerName: "Vivo",
  },
  puffersvssharks: {
    href: "/casino/pragmaticplay-puffers-vs-sharks",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PuffersvsSharks.webp",
    alt: "Puffers vs Sharks",
    name: "Puffers vs Sharks",
    providerName: "Vivo",
  },
  pubkings: {
    href: "/casino/pragmaticplay-pub-kings",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PubKings.webp",
    alt: "Pub Kings",
    name: "Pub Kings",
    providerName: "Vivo",
  },
  powerofthormegaways: {
    href: "/casino/pragmaticplay-power-of-thor-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PowerofThorMegaways.webp",
    alt: "Power of Thor Megaways",
    name: "Power of Thor Megaways",
    providerName: "Vivo",
  },
  powerofninja: {
    href: "/casino/pragmaticplay-power-of-ninja",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PowerofNinja.webp",
    alt: "Power of Ninja",
    name: "Power of Ninja",
    providerName: "Vivo",
  },
  potoffortune: {
    href: "/casino/pragmaticplay-pot-of-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PotofFortune.webp",
    alt: "Pot of Fortune",
    name: "Pot of Fortune",
    providerName: "Vivo",
  },
  pompeiimegareelsmegaways: {
    href: "/casino/pragmaticplay-pompeii-megareels-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PompeiiMegareelsMegaways.webp",
    alt: "Pompeii Megareels Megaways",
    name: "Pompeii Megareels Megaways",
    providerName: "Vivo",
  },
  pizzapizzapizza: {
    href: "/casino/pragmaticplay-pizza-pizza-pizza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PIZZAPIZZAPIZZA.webp",
    alt: "PIZZA PIZZA PIZZA",
    name: "PIZZA PIZZA PIZZA",
    providerName: "Vivo",
  },
  pixiewings: {
    href: "/casino/pragmaticplay-pixie-wings",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PixieWings.webp",
    alt: "Pixie Wings",
    name: "Pixie Wings",
    providerName: "Vivo",
  },
  piratespub: {
    href: "/casino/pragmaticplay-pirates-pub",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PiratesPub.webp",
    alt: "Pirates Pub",
    name: "Pirates Pub",
    providerName: "Vivo",
  },
  piratequest1000: {
    href: "/casino/pragmaticplay-pirate-quest-1000",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PirateQuest1000.webp",
    alt: "Pirate Quest 1000",
    name: "Pirate Quest 1000",
    providerName: "Vivo",
  },
  pirategolddeluxe: {
    href: "/casino/pragmaticplay-pirate-gold-deluxe",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PirateGoldDeluxe.webp",
    alt: "Pirate Gold Deluxe",
    name: "Pirate Gold Deluxe",
    providerName: "Vivo",
  },
  pirategold: {
    href: "/casino/pragmaticplay-pirate-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PirateGold.webp",
    alt: "Pirate Gold",
    name: "Pirate Gold",
    providerName: "Vivo",
  },
  pinupgirls: {
    href: "/casino/pragmaticplay-pinup-girls",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PinupGirls.webp",
    alt: "Pinup Girls",
    name: "Pinup Girls",
    providerName: "Vivo",
  },
  piggyrockparty: {
    href: "/casino/pragmaticplay-piggy-rock-party",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PiggyRockParty.webp",
    alt: "Piggy Rock Party",
    name: "Piggy Rock Party",
    providerName: "Vivo",
  },
  piggybankbills: {
    href: "/casino/pragmaticplay-piggy-bank-bills",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PiggyBankBills.webp",
    alt: "Piggy Bank Bills",
    name: "Piggy Bank Bills",
    providerName: "Vivo",
  },
  phoenixforge: {
    href: "/casino/pragmaticplay-phoenix-forge",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PhoenixForge.webp",
    alt: "Phoenix Forge",
    name: "Phoenix Forge",
    providerName: "Vivo",
  },
  peppespepperonipizzaplaza: {
    href: "/casino/pragmaticplay-peppes-pepperoni-pizza-plaza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PeppesPepperoniPizzaPlaza.webp",
    alt: "Peppes Pepperoni Pizza Plaza",
    name: "Peppes Pepperoni Pizza Plaza",
    providerName: "Vivo",
  },
  penguinschristmaspartytime: {
    href: "/casino/pragmaticplay-penguins-christmas-party-time",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PenguinsChristmasPartyTime.webp",
    alt: "Penguins Christmas Party Time",
    name: "Penguins Christmas Party Time",
    providerName: "Vivo",
  },
  pekingluck: {
    href: "/casino/pragmaticplay-peking-luck",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PekingLuck.webp",
    alt: "Peking Luck",
    name: "Peking Luck",
    providerName: "Vivo",
  },
  peakpower: {
    href: "/casino/pragmaticplay-peak-power",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PeakPower.webp",
    alt: "Peak Power",
    name: "Peak Power",
    providerName: "Vivo",
  },
  pantherqueen: {
    href: "/casino/pragmaticplay-panther-queen",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PantherQueen.webp",
    alt: "Panther Queen",
    name: "Panther Queen",
    providerName: "Vivo",
  },
  pandafortune2: {
    href: "/casino/pragmaticplay-panda-fortune-2",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PandaFortune2.webp",
    alt: "Panda Fortune 2",
    name: "Panda Fortune 2",
    providerName: "Vivo",
  },
  pandafortune: {
    href: "/casino/pragmaticplay-panda-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/PandaFortune.webp",
    alt: "Panda Fortune",
    name: "Panda Fortune",
    providerName: "Vivo",
  },
  oodlesofnoodles: {
    href: "/casino/pragmaticplay-oodles-of-noodles",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/OodlesofNoodles.webp",
    alt: "Oodles of Noodles",
    name: "Oodles of Noodles",
    providerName: "Vivo",
  },
  oly: {
    href: "/casino/pragmaticplay-oly",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/oly.webp",
    alt: "Oly",
    name: "Oly",
    providerName: "Vivo",
  },
  oishiibonanza: {
    href: "/casino/pragmaticplay-oishii-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/OishiiBonanza.webp",
    alt: "Oishii Bonanza",
    name: "Oishii Bonanza",
    providerName: "Vivo",
  },
  octobeerfortunes: {
    href: "/casino/pragmaticplay-octobeer-fortunes",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/OctobeerFortunes.webp",
    alt: "Octobeer Fortunes",
    name: "Octobeer Fortunes",
    providerName: "Vivo",
  },
  northguardians: {
    href: "/casino/pragmaticplay-north-guardians",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/NorthGuardians.webp",
    alt: "North Guardians",
    name: "North Guardians",
    providerName: "Vivo",
  },
  nilefortunes: {
    href: "/casino/pragmaticplay-nile-fortunes",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/NileFortunes.webp",
    alt: "Nile Fortunes",
    name: "Nile Fortunes",
    providerName: "Vivo",
  },
  nexusgatesofolympus: {
    href: "/casino/pragmaticplay-nexus-gates-of-olympus",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/nexusgatesofolympus.webp",
    alt: "Nexus Gates of Olympus",
    name: "Nexus Gates of Olympus",
    providerName: "Vivo",
  },
  newyeartigertreasures: {
    href: "/casino/pragmaticplay-new-year-tiger-treasures",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/NewYearTigerTreasures.webp",
    alt: "New Year Tiger Treasures",
    name: "New Year Tiger Treasures",
    providerName: "Vivo",
  },
  newtalesofegypt: {
    href: "/casino/pragmaticplay-new-tales-of-egypt",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/NewTalesofEgypt.webp",
    alt: "New Tales of Egypt",
    name: "New Tales of Egypt",
    providerName: "Vivo",
  },
  mysticchief: {
    href: "/casino/pragmaticplay-mystic-chief",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MysticChief.webp",
    alt: "Mystic Chief",
    name: "Mystic Chief",
    providerName: "Vivo",
  },
  mysteryoftheorient: {
    href: "/casino/pragmaticplay-mystery-of-the-orient",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/mysteryoftheorient.jpg",
    alt: "Mystery of the Orient",
    name: "Mystery of the Orient",
    providerName: "Vivo",
  },
  mysterymice: {
    href: "/casino/pragmaticplay-mystery-mice",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MysteryMice.webp",
    alt: "Mystery Mice",
    name: "Mystery Mice",
    providerName: "Vivo",
  },
  mysteriousegypt: {
    href: "/casino/pragmaticplay-mysterious-egypt",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MysteriousEgypt.webp",
    alt: "Mysterious Egypt",
    name: "Mysterious Egypt",
    providerName: "Vivo",
  },
  mustangtrail: {
    href: "/casino/pragmaticplay-mustang-trail",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MustangTrail.webp",
    alt: "Mustang Trail",
    name: "Mustang Trail",
    providerName: "Vivo",
  },
  mustanggold: {
    href: "/casino/pragmaticplay-mustang-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MustangGold.webp",
    alt: "Mustang Gold",
    name: "Mustang Gold",
    providerName: "Vivo",
  },
  mummysjewels: {
    href: "/casino/pragmaticplay-mummys-jewels",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MummysJewel.webp",
    alt: "Mummy's Jewels",
    name: "Mummy's Jewels",
    providerName: "Vivo",
  },
  muertosmultipliermegaways: {
    href: "/casino/pragmaticplay-muertos-multiplier-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MuertosMultiplierMegaways.webp",
    alt: "Muertos Multiplier Megaways",
    name: "Muertos Multiplier Megaways",
    providerName: "Vivo",
  },
  mrtainsfurywildwildgladiator: {
    href: "/casino/pragmaticplay-mr-tains-fury-wild-wild-gladiator",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MrTainsFuryWildWildGladiator.webp",
    alt: "Mr Tain's Fury: Wild Wild Gladiator",
    name: "Mr Tain's Fury: Wild Wild Gladiator",
    providerName: "Vivo",
  },
  mrtainsfishingadventures: {
    href: "/casino/pragmaticplay-mr-tains-fishing-adventures",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MrTainsFishingAdventures.webp",
    alt: "Mr Tains Fishing Adventures",
    name: "Mr Tains Fishing Adventures",
    providerName: "Vivo",
  },
  mpoplayaztecgems: {
    href: "/casino/pragmaticplay-mpoplay-aztec-gems",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MPOPLAYAztecGems.webp",
    alt: "MPOPLAY Aztec Gems",
    name: "MPOPLAY Aztec Gems",
    providerName: "Vivo",
  },
  moonshot: {
    href: "/casino/pragmaticplay-moonshot",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Moonshot.webp",
    alt: "Moonshot",
    name: "Moonshot",
    providerName: "Vivo",
  },
  monstersuperlanche: {
    href: "/casino/pragmaticplay-monster-superlanche",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MonsterSuperlanche.webp",
    alt: "Monster Superlanche",
    name: "Monster Superlanche",
    providerName: "Vivo",
  },
  monkeywarrior: {
    href: "/casino/pragmaticplay-monkey-warrior",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MonkeyWarrior.webp",
    alt: "Monkey Warrior",
    name: "Monkey Warrior",
    providerName: "Vivo",
  },
  monkeymadness: {
    href: "/casino/pragmaticplay-monkey-madness",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MonkeyMadness.webp",
    alt: "Monkey Madness",
    name: "Monkey Madness",
    providerName: "Vivo",
  },
  moneystacks: {
    href: "/casino/pragmaticplay-money-stacks",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MoneyStacks.webp",
    alt: "Money Stacks",
    name: "Money Stacks",
    providerName: "Vivo",
  },
  moneymouse: {
    href: "/casino/pragmaticplay-money-mouse",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MoneyMouse.webp",
    alt: "Money Mouse",
    name: "Money Mouse",
    providerName: "Vivo",
  },
  moneymoneymoney: {
    href: "/casino/pragmaticplay-money-money-money",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MoneyMoneyMoney.webp",
    alt: "Money Money Money",
    name: "Money Money Money",
    providerName: "Vivo",
  },
  moleionaire: {
    href: "/casino/pragmaticplay-moleionaire",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Moleionaire.webp",
    alt: "Moleionaire",
    name: "Moleionaire",
    providerName: "Vivo",
  },
  mochimon: {
    href: "/casino/pragmaticplay-mochimon",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Mochimon.webp",
    alt: "Mochimon",
    name: "Mochimon",
    providerName: "Vivo",
  },
  miningrush: {
    href: "/casino/pragmaticplay-mining-rush",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MiningRush.webp",
    alt: "Mining Rush",
    name: "Mining Rush",
    providerName: "Vivo",
  },
  mightykong: {
    href: "/casino/pragmaticplay-mighty-kong",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MightyKong.webp",
    alt: "Mighty Kong",
    name: "Mighty Kong",
    providerName: "Vivo",
  },
  mightyhercules: {
    href: "/casino/pragmaticplay-mighty-hercules",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MightyHercules.webp",
    alt: "Mighty Hercules",
    name: "Mighty Hercules",
    providerName: "Vivo",
  },
  mightofra: {
    href: "/casino/pragmaticplay-might-of-ra",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MightofRa.webp",
    alt: "Might of Ra",
    name: "Might of Ra",
    providerName: "Vivo",
  },
  medusasstone: {
    href: "/casino/pragmaticplay-medusas-stone",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MedusasStone.webp",
    alt: "Medusa's Stone",
    name: "Medusa's Stone",
    providerName: "Vivo",
  },
  masterjoker: {
    href: "/casino/pragmaticplay-master-joker",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MasterJoker.webp",
    alt: "Master Joker",
    name: "Master Joker",
    providerName: "Vivo",
  },
  mastergems: {
    href: "/casino/pragmaticplay-master-gems",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MasterGems.webp",
    alt: "Master Gems",
    name: "Master Gems",
    providerName: "Vivo",
  },
  masterchensfortune: {
    href: "/casino/pragmaticplay-master-chens-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MasterChensFortune.webp",
    alt: "Master Chens Fortune",
    name: "Master Chens Fortune",
    providerName: "Vivo",
  },
  mammothgoldmegaways: {
    href: "/casino/pragmaticplay-mammoth-gold-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MammothGoldMegaways.webp",
    alt: "Mammoth Gold Megaways",
    name: "Mammoth Gold Megaways",
    providerName: "Vivo",
  },
  majesticexpressgoldrun: {
    href: "/casino/pragmaticplay-majestic-express-gold-run",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MajesticExpressGoldRun.webp",
    alt: "Majestic Express Gold Run",
    name: "Majestic Express Gold Run",
    providerName: "Vivo",
  },
  mahjongx: {
    href: "/casino/pragmaticplay-mahjong-x",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MahjongX.webp",
    alt: "Mahjong X",
    name: "Mahjong X",
    providerName: "Vivo",
  },
  mahjongwinssuperscatter: {
    href: "/casino/pragmaticplay-mahjong-wins-super-scatter",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MahjongWinsSuperScatter.webp",
    alt: "Mahjong Wins Super Scatter",
    name: "Mahjong Wins Super Scatter",
    providerName: "Vivo",
  },
  mahjongwinsbonus: {
    href: "/casino/pragmaticplay-mahjong-wins-bonus",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MahjongWinsBonus.webp",
    alt: "Mahjong Wins Bonus",
    name: "Mahjong Wins Bonus",
    providerName: "Vivo",
  },
  mahjongwins3blackscatter: {
    href: "/casino/pragmaticplay-mahjong-wins-3-black-scatter",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MahjongWins3BlackScatter.webp",
    alt: "Mahjong Wins 3 - Black Scatter",
    name: "Mahjong Wins 3 - Black Scatter",
    providerName: "Vivo",
  },
  mahjongwins2: {
    href: "/casino/pragmaticplay-mahjong-wins-2",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MahjongWins2.webp",
    alt: "Mahjong Wins 2",
    name: "Mahjong Wins 2",
    providerName: "Vivo",
  },
  mahjongwinsgongxifacai: {
    href: "/casino/pragmaticplay-mahjong-wins-gong-xi-fa-cai",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MahjongWinsGongXiFaCai.webp",
    alt: "Mahjong Wins - Gong Xi Fa Cai",
    name: "Mahjong Wins - Gong Xi Fa Cai",
    providerName: "Vivo",
  },
  mahjongwins: {
    href: "/casino/pragmaticplay-mahjong-wins",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MahjongWins.webp",
    alt: "Mahjong Wins",
    name: "Mahjong Wins",
    providerName: "Vivo",
  },
  mahjongpanda: {
    href: "/casino/pragmaticplay-mahjong-panda",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MahjongPanda.webp",
    alt: "Mahjong Panda",
    name: "Mahjong Panda",
    providerName: "Vivo",
  },
  mahjongbonanza: {
    href: "/casino/pragmaticplay-mahjong-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MahjongBonanza.webp",
    alt: "Mahjong Bonanza",
    name: "Mahjong Bonanza",
    providerName: "Vivo",
  },
  magicianssecrets: {
    href: "/casino/pragmaticplay-magicians-secrets",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MagiciansSecrets.webp",
    alt: "Magicians Secrets",
    name: "Magicians Secrets",
    providerName: "Vivo",
  },
  magicmoneymaze: {
    href: "/casino/pragmaticplay-magic-money-maze",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MagicMoneyMaze.webp",
    alt: "Magic Money Maze",
    name: "Magic Money Maze",
    providerName: "Vivo",
  },
  magicjourney: {
    href: "/casino/pragmaticplay-magic-journey",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MagicJourne.webp",
    alt: "Magic Journey",
    name: "Magic Journey",
    providerName: "Vivo",
  },
  magiccrystals: {
    href: "/casino/pragmaticplay-magic-crystals",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MagicCrysta.webp",
    alt: "Magic Crystals",
    name: "Magic Crystals",
    providerName: "Vivo",
  },
  madamemystiquemegaways: {
    href: "/casino/pragmaticplay-madame-mystique-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MadameMystiqueMegaways.webp",
    alt: "Madame Mystique Megaways",
    name: "Madame Mystique Megaways",
    providerName: "Vivo",
  },
  madamedestinymegaways: {
    href: "/casino/pragmaticplay-madame-destiny-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MadameDestinyMegaways.webp",
    alt: "Madame Destiny Megaways",
    name: "Madame Destiny Megaways",
    providerName: "Vivo",
  },
  madamedestiny: {
    href: "/casino/pragmaticplay-madame-destiny",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/MadameDestiny.webp",
    alt: "Madame Destiny",
    name: "Madame Destiny",
    providerName: "Vivo",
  },
  hockeyleague: {
    href: "/casino/pragmaticplay-hockey-league",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HockeyLeague.webp",
    alt: "Hockey League",
    name: "Hockey League",
    providerName: "Vivo",
  },
  hockeybonanza: {
    href: "/casino/pragmaticplay-hockey-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HockeyBonanza.webp",
    alt: "Hockey Bonanza",
    name: "Hockey Bonanza",
    providerName: "Vivo",
  },
  hockeyattack: {
    href: "/casino/pragmaticplay-hockey-attack",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HockeyAttack.webp",
    alt: "Hockey Attack",
    name: "Hockey Attack",
    providerName: "Vivo",
  },
  himalayanwild: {
    href: "/casino/pragmaticplay-himalayan-wild",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HimalayanWild.webp",
    alt: "Himalayan Wild",
    name: "Himalayan Wild",
    providerName: "Vivo",
  },
  heroicspins: {
    href: "/casino/pragmaticplay-heroic-spins",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HeroicSpins.webp",
    alt: "Heroic Spins",
    name: "Heroic Spins",
    providerName: "Vivo",
  },

  herculessonofzeus: {
    href: "/casino/pragmaticplay-hercules-son-of-zeus",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HerculesSonofZeus.webp",
    alt: "Hercules Son of Zeus",
    name: "Hercules Son of Zeus",
    providerName: "Vivo",
  },
  herculesandpegasus: {
    href: "/casino/pragmaticplay-hercules-and-pegasus",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HerculesandPegasus.webp",
    alt: "Hercules and Pegasus",
    name: "Hercules and Pegasus",
    providerName: "Vivo",
  },
  heistforthegoldennuggets: {
    href: "/casino/pragmaticplay-heist-for-the-golden-nuggets",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HeistfortheGoldenNuggets.webp",
    alt: "Heist for the Golden Nuggets",
    name: "Heist for the Golden Nuggets",
    providerName: "Vivo",
  },
  heartofrio: {
    href: "/casino/pragmaticplay-heart-of-rio",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HeartofRio.webp",
    alt: "Heart of Rio",
    name: "Heart of Rio",
    providerName: "Vivo",
  },
  heartofcleopatra: {
    href: "/casino/pragmaticplay-heart-of-cleopatra",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HeartofCleopatra.webp",
    alt: "Heart of Cleopatra",
    name: "Heart of Cleopatra",
    providerName: "Vivo",
  },
  havefesten: {
    href: "/casino/pragmaticplay-havefesten",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Havefesten.webp",
    alt: "Havefesten",
    name: "Havefesten",
    providerName: "Vivo",
  },
  happyhooves: {
    href: "/casino/pragmaticplay-happy-hooves",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HappyHooves.webp",
    alt: "Happy Hooves",
    name: "Happy Hooves",
    providerName: "Vivo",
  },
  happyfortune: {
    href: "/casino/pragmaticplay-happy-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HappyFortune.webp",
    alt: "Happy Fortune",
    name: "Happy Fortune",
    providerName: "Vivo",
  },
  handofmidas2: {
    href: "/casino/pragmaticplay-hand-of-midas-2",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/HandofMidas2.webp",
    alt: "Hand of Midas 2",
    name: "Hand of Midas 2",
    providerName: "Vivo",
  },
  guaranaeyesoftheamazon: {
    href: "/casino/pragmaticplay-guarana-eyes-of-the-amazon",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GuaranaEyesoftheAmazon.webp",
    alt: "Guarana Eyes of the Amazon",
    name: "Guarana Eyes of the Amazon",
    providerName: "Vivo",
  },
  gretzkypowerpucks: {
    href: "/casino/pragmaticplay-gretzky-power-pucks",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GretzkyPowerPucks.webp",
    alt: "Gretzky Power Pucks",
    name: "Gretzky Power Pucks",
    providerName: "Vivo",
  },
  greekgods: {
    href: "/casino/pragmaticplay-greek-gods",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GreekGods.webp",
    alt: "Greek Gods",
    name: "Greek Gods",
    providerName: "Vivo",
  },
  greedywolf: {
    href: "/casino/pragmaticplay-greedy-wolf",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GreedyWolf.webp",
    alt: "Greedy Wolf",
    name: "Greedy Wolf",
    providerName: "Vivo",
  },
  greedyfortunepig: {
    href: "/casino/pragmaticplay-greedy-fortune-pig",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GreedyFortunePig.webp",
    alt: "Greedy Fortune Pig",
    name: "Greedy Fortune Pig",
    providerName: "Vivo",
  },
  greatrhinomegaways: {
    href: "/casino/pragmaticplay-great-rhino-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GreatRhinoMegaways.webp",
    alt: "Great Rhino Megaways",
    name: "Great Rhino Megaways",
    providerName: "Vivo",
  },
  greatrhinodeluxe: {
    href: "/casino/pragmaticplay-great-rhino-deluxe",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GreatRhinoDeluxe.webp",
    alt: "Great Rhino Deluxe",
    name: "Great Rhino Deluxe",
    providerName: "Vivo",
  },
  greatrhino: {
    href: "/casino/pragmaticplay-great-rhino",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GreatRhino.webp",
    alt: "Great Rhino",
    name: "Great Rhino",
    providerName: "Vivo",
  },
  greatreef: {
    href: "/casino/pragmaticplay-great-reef",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GreatReef.webp",
    alt: "Great Reef",
    name: "Great Reef",
    providerName: "Vivo",
  },
  gravitybonanza: {
    href: "/casino/pragmaticplay-gravity-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GravityBonanza.webp",
    alt: "Gravity Bonanza",
    name: "Gravity Bonanza",
    providerName: "Vivo",
  },
  graceofebisu: {
    href: "/casino/pragmaticplay-grace-of-ebisu",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GraceofEbisu.webp",
    alt: "Grace of Ebisu",
    name: "Grace of Ebisu",
    providerName: "Vivo",
  },
  gorillamayhem: {
    href: "/casino/pragmaticplay-gorilla-mayhem",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GorillaMayhem.webp",
    alt: "Gorilla Mayhem",
    name: "Gorilla Mayhem",
    providerName: "Vivo",
  },
  goldenpig: {
    href: "/casino/pragmaticplay-golden-pig",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GoldenPig.webp",
    alt: "Golden Pig",
    name: "Golden Pig",
    providerName: "Vivo",
  },
  goldenox: {
    href: "/casino/pragmaticplay-golden-ox",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GoldenOx.webp",
    alt: "Golden Ox",
    name: "Golden Ox",
    providerName: "Vivo",
  },
  goldtraingpk: {
    href: "/casino/pragmaticplay-gold-train-gpk",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GoldTrainGPK.webp",
    alt: "Gold Train GPK",
    name: "Gold Train GPK",
    providerName: "Vivo",
  },
  goldtrain: {
    href: "/casino/pragmaticplay-gold-train",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GoldTrain.webp",
    alt: "Gold Train",
    name: "Gold Train",
    providerName: "Vivo",
  },
  goldrush: {
    href: "/casino/pragmaticplay-gold-rush",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GoldRush.webp",
    alt: "Gold Rush",
    name: "Gold Rush",
    providerName: "Vivo",
  },
  goldparty2afterhours: {
    href: "/casino/pragmaticplay-gold-party-2-after-hours",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GoldParty2AfterHours.webp",
    alt: "Gold Party 2 - After Hours",
    name: "Gold Party 2 - After Hours",
    providerName: "Vivo",
  },
  goldparty: {
    href: "/casino/pragmaticplay-gold-party",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GoldParty.webp",
    alt: "Gold Party",
    name: "Gold Party",
    providerName: "Vivo",
  },
  goldcarpbonanza: {
    href: "/casino/pragmaticplay-gold-carp-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GoldCarpBonanza.webp",
    alt: "Gold Carp Bonanza",
    name: "Gold Carp Bonanza",
    providerName: "Vivo",
  },
  godsofgiza: {
    href: "/casino/pragmaticplay-gods-of-giza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GodsofGiza.webp",
    alt: "Gods of Giza",
    name: "Gods of Giza",
    providerName: "Vivo",
  },
  goblinheistpowernudge: {
    href: "/casino/pragmaticplay-goblin-heist-powernudge",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GoblinHeistPowerNudg.webp",
    alt: "Goblin Heist PowerNudge",
    name: "Goblin Heist PowerNudge",
    providerName: "Vivo",
  },
  gloriousrome: {
    href: "/casino/pragmaticplay-glorious-rome",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GloriousRome.webp",
    alt: "Glorious Rome",
    name: "Glorious Rome",
    providerName: "Vivo",
  },
  gemsbonanza: {
    href: "/casino/pragmaticplay-gems-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GemsBonanza.webp",
    alt: "Gems Bonanza",
    name: "Gems Bonanza",
    providerName: "Vivo",
  },
  gemine: {
    href: "/casino/pragmaticplay-gemine",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Gemine.webp",
    alt: "Gemine",
    name: "Gemine",
    providerName: "Vivo",
  },
  gemtrio: {
    href: "/casino/pragmaticplay-gem-trio",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GemTrio.webp",
    alt: "Gem Trio",
    name: "Gem Trio",
    providerName: "Vivo",
  },
  gemfirefortune: {
    href: "/casino/pragmaticplay-gem-fire-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GemFireFortune.webp",
    alt: "Gem Fire Fortune",
    name: "Gem Fire Fortune",
    providerName: "Vivo",
  },
  gemelevator: {
    href: "/casino/pragmaticplay-gem-elevator",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GemElevator.webp",
    alt: "Gem Elevator",
    name: "Gem Elevator",
    providerName: "Vivo",
  },
  gearsofhorus: {
    href: "/casino/pragmaticplay-gears-of-horus",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GearsofHorus.webp",
    alt: "Gears of Horus",
    name: "Gears of Horus",
    providerName: "Vivo",
  },
  gatotkacasfury: {
    href: "/casino/pragmaticplay-gatot-kacas-fury",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GatotKacasFury.webp",
    alt: "Gatot Kacas Fury",
    name: "Gatot Kacas Fury",
    providerName: "Vivo",
  },
  gatestoeldorado: {
    href: "/casino/pragmaticplay-gates-to-el-dorado",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/gatestoeldorado.webp",
    alt: "Gates to El Dorado",
    name: "Gates to El Dorado",
    providerName: "Vivo",
  },
  gatesofxibalba: {
    href: "/casino/pragmaticplay-gates-of-xibalba",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GatesofXibalba.webp",
    alt: "Gates of Xibalba",
    name: "Gates of Xibalba",
    providerName: "Vivo",
  },
  gatesofvalhalla: {
    href: "/casino/pragmaticplay-gates-of-valhalla",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GatesofValhalla.webp",
    alt: "Gates of Valhalla",
    name: "Gates of Valhalla",
    providerName: "Vivo",
  },
  gatesofolympusxmas1000: {
    href: "/casino/pragmaticplay-gates-of-olympus-xmas-1000",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GatesofOlympusXmas1000.webp",
    alt: "Gates of Olympus Xmas 1000",
    name: "Gates of Olympus Xmas 1000",
    providerName: "Vivo",
  },
  gatesofolympussuper: {
    href: "/casino/pragmaticplay-gates-of-olympus-super-scatter",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GatesofOlympusSUPERSCATTER.webp",
    alt: "Gates of Olympus SUPER SCATTER",
    name: "Gates of Olympus SUPER SCATTER",
    providerName: "Vivo",
  },
  gatesofolympusdice: {
    href: "/casino/pragmaticplay-gates-of-olympus-dice",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GatesofOlympusDice.webp",
    alt: "Gates of Olympus Dice",
    name: "Gates of Olympus Dice",
    providerName: "Vivo",
  },
  gatesofolympus1000dice: {
    href: "/casino/pragmaticplay-gates-of-olympus-1000-dice",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GatesofOlympus1000Dice.webp",
    alt: "Gates of Olympus 1000 Dice",
    name: "Gates of Olympus 1000 Dice",
    providerName: "Vivo",
  },
  gatesofolympus1000: {
    href: "/casino/pragmaticplay-gates-of-olympus-1000",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GatesofOlympus1000.webp",
    alt: "Gates of Olympus 1000",
    name: "Gates of Olympus 1000",
    providerName: "Vivo",
  },

  gatesofmars: {
    href: "/casino/pragmaticplay-gates-of-mars",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/gatesofmars.webp",
    alt: "Gates of Mars",
    name: "Gates of Mars",
    providerName: "Vivo",
  },
  gatesofleovegas1000: {
    href: "/casino/pragmaticplay-gates-of-leovegas-1000",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GatesofLeoVegas1000.webp",
    alt: "Gates of LeoVegas 1000",
    name: "Gates of LeoVegas 1000",
    providerName: "Vivo",
  },
  gatesofhunny: {
    href: "/casino/pragmaticplay-gates-of-hunny",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/gatesofhunny.webp",
    alt: "Gates of LeoVegas 1000",
    name: "Gates of LeoVegas 1000",
    providerName: "Vivo",
  },
  gatesofheaven: {
    href: "/casino/pragmaticplay-gates-of-heaven",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GatesofHeaven.webp",
    alt: "Gates of Heaven",
    name: "Gates of Heaven",
    providerName: "Vivo",
  },

  gatesofgatotkaca: {
    href: "/casino/pragmaticplay-gates-of-gatotkaca",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GatesofGatotkaca.webp",
    alt: "Gates of Gatotkaca",
    name: "Gates of Gatotkaca",
    providerName: "Vivo",
  },
  gatesofgatotkaca1000: {
    href: "/casino/pragmaticplay-gates-of-gatot-kaca-1000",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GatesofGatotKaca1000.webp",
    alt: "Gates of Gatot Kaca 1000",
    name: "Gates of Gatot Kaca 1000",
    providerName: "Vivo",
  },
  gatesofdragonjackpotplay: {
    href: "/casino/pragmaticplay-gates-of-dragon-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GatesofDragonJackpotPlay.webp",
    alt: "Gates of Dragon Jackpot Play",
    name: "Gates of Dragon Jackpot Play",
    providerName: "Vivo",
  },
  gatesofcresus: {
    href: "/casino/pragmaticplay-gates-of-cresus",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GatesofCresus.webp",
    alt: "Gates of Cresus",
    name: "Gates of Cresus",
    providerName: "Vivo",
  },
  gatesofaztec: {
    href: "/casino/pragmaticplay-gates-of-aztec",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GatesofAztec.webp",
    alt: "Gates of Aztec",
    name: "Gates of Aztec",
    providerName: "Vivo",
  },
  gameshowpartyjackpotplay: {
    href: "/casino/pragmaticplay-gameshow-party-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GameshowPartyJackpotPlay.webp",
    alt: "Gameshow Party Jackpot Play",
    name: "Gameshow Party Jackpot Play",
    providerName: "Vivo",
  },
  gamesinolympus: {
    href: "/casino/pragmaticplay-games-in-olympus",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/GamesinOlympus.webp",
    alt: "Games in Olympus",
    name: "Games in Olympus",
    providerName: "Vivo",
  },
  furyofodinmegaways: {
    href: "/casino/pragmaticplay-fury-of-odin-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FuryofOdinMegaways.webp",
    alt: "Fury of Odin Megaways",
    name: "Fury of Odin Megaways",
    providerName: "Vivo",
  },
  fun88dragons: {
    href: "/casino/pragmaticplay-fun88-dragons",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Fun88Dragons.webp",
    alt: "Fun88 Dragons",
    name: "Fun88 Dragons",
    providerName: "Vivo",
  },
  fufufu: {
    href: "/casino/pragmaticplay-fu-fu-fu",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FuFuFu.webp",
    alt: "Fu Fu Fu",
    name: "Fu Fu Fu",
    providerName: "Vivo",
  },
  fruitytreats: {
    href: "/casino/pragmaticplay-fruity-treats",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FruityTreats.webp",
    alt: "Fruity Treats",
    name: "Fruity Treats",
    providerName: "Vivo",
  },
  fruityblast: {
    href: "/casino/pragmaticplay-fruity-blast",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FruityBlast.webp",
    alt: "Fruity Blast",
    name: "Fruity Blast",
    providerName: "Vivo",
  },
  fruitsoftheamazon: {
    href: "/casino/pragmaticplay-fruits-of-the-amazon",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FruitsoftheAmazon.webp",
    alt: "Fruits of the Amazon",
    name: "Fruits of the Amazon",
    providerName: "Vivo",
  },
  fruitrainbow: {
    href: "/casino/pragmaticplay-fruit-rainbow",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FruitRainbow.webp",
    alt: "Fruit Rainbow",
    name: "Fruit Rainbow",
    providerName: "Vivo",
  },
  fruitparty2: {
    href: "/casino/pragmaticplay-fruit-party-2",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FruitParty2.webp",
    alt: "Fruit Party 2",
    name: "Fruit Party 2",
    providerName: "Vivo",
  },
  fruitparty: {
    href: "/casino/pragmaticplay-fruit-party",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FruitParty.webp",
    alt: "Fruit Party",
    name: "Fruit Party",
    providerName: "Vivo",
  },
  frontrunneroddson: {
    href: "/casino/pragmaticplay-front-runner-odds-on",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FrontRunnerOddsOn.webp",
    alt: "Front Runner Odds On",
    name: "Front Runner Odds On",
    providerName: "Vivo",
  },
  frogsandfruits: {
    href: "/casino/pragmaticplay-frogs-and-fruits",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FrogsandFruits.webp",
    alt: "Frogs and Fruits",
    name: "Frogs and Fruits",
    providerName: "Vivo",
  },
  fortunesofaztec: {
    href: "/casino/pragmaticplay-fortunes-of-aztec",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FortunesofAztec.webp",
    alt: "Fortunes of Aztec",
    name: "Fortunes of Aztec",
    providerName: "Vivo",
  },
  fortuneofgiza: {
    href: "/casino/pragmaticplay-fortune-of-giza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FortuneofGiza.webp",
    alt: "Fortune of Giza",
    name: "Fortune of Giza",
    providerName: "Vivo",
  },
  fortunehitnroll: {
    href: "/casino/pragmaticplay-fortune-hitn-roll",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FortuneHitnRoll.webp",
    alt: "Fortune Hit'n Roll",
    name: "Fortune Hit'n Roll",
    providerName: "Vivo",
  },
  fortuneace: {
    href: "/casino/pragmaticplay-fortune-ace",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FortuneAce.webp",
    alt: "Fortune Ace",
    name: "Fortune Ace",
    providerName: "Vivo",
  },
  forgingwilds: {
    href: "/casino/pragmaticplay-forging-wilds",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ForgingWilds.webp",
    alt: "Forging Wilds",
    name: "Forging Wilds",
    providerName: "Vivo",
  },
  forgeofolympus: {
    href: "/casino/pragmaticplay-forge-of-olympus",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ForgeofOlympus.webp",
    alt: "Forge of Olympus",
    name: "Forge of Olympus",
    providerName: "Vivo",
  },
  fonzosfelinefortunes: {
    href: "/casino/pragmaticplay-fonzos-feline-fortunes",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FonzosFelineFortunes.webp",
    alt: "Fonzos Feline Fortunes",
    name: "Fonzos Feline Fortunes",
    providerName: "Vivo",
  },
  flyinghippo: {
    href: "/casino/pragmaticplay-flying-hippo",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FlyingHippo.webp",
    alt: "Flying Hippo",
    name: "Flying Hippo",
    providerName: "Vivo",
  },
  floatingdragonyearofthesnake: {
    href: "/casino/pragmaticplay-floating-dragon-year-of-the-snake",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FloatingDragonYearoftheSnake.webp",
    alt: "Floating Dragon Year of the Snake",
    name: "Floating Dragon Year of the Snake",
    providerName: "Vivo",
  },
  floatingdragonnewyearfestivalultramegawaysholdspin: {
    href: "/casino/pragmaticplay-floating-dragon-new-year-festival-ultra-megaways-hold-and-spin",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl:
      "/images/pragmaticplay/FloatingDragonNewYearFestivalUltraMegawaysHold&Spin.webp",
    alt: "Floating Dragon New Year Festival Ultra Megaways Hold & Spin",
    name: "Floating Dragon New Year Festival Ultra Megaways Hold & Spin",
    providerName: "Vivo",
  },
  floatingdragonholdspinmegaways: {
    href: "/casino/pragmaticplay-floating-dragon-hold-and-spin-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FloatingDragonHold&SpinMegaways.webp",
    alt: "Floating Dragon Hold & Spin Megaways",
    name: "Floating Dragon Hold & Spin Megaways",
    providerName: "Vivo",
  },
  floatingdragondragonboatfestival: {
    href: "/casino/pragmaticplay-floating-dragon-dragon-boat-festival",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FloatingDragon-DragonBoatFestiva.webp",
    alt: "Floating Dragon  Dragon Boat Festival",
    name: "Floating Dragon  Dragon Boat Festival",
    providerName: "Vivo",
  },
  floatingdragon: {
    href: "/casino/pragmaticplay-floating-dragon",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FloatingDragon.webp",
    alt: "Floating Dragon",
    name: "Floating Dragon",
    providerName: "Vivo",
  },
  fishinreels: {
    href: "/casino/pragmaticplay-fishin-reels",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FishinReels.webp",
    alt: "Fishin Reels",
    name: "Fishin Reels",
    providerName: "Vivo",
  },
  fisheye: {
    href: "/casino/pragmaticplay-fish-eye",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FishEye.webp",
    alt: "Fish Eye",
    name: "Fish Eye",
    providerName: "Vivo",
  },
  firestrike2: {
    href: "/casino/pragmaticplay-fire-strike-2",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FireStrike2.webp",
    alt: "Fire Strike 2",
    name: "Fire Strike 2",
    providerName: "Vivo",
  },
  firestrike: {
    href: "/casino/pragmaticplay-fire-strike",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FireStrike.webp",
    alt: "Fire Strike",
    name: "Fire Strike",
    providerName: "Vivo",
  },
  firestampede: {
    href: "/casino/pragmaticplay-fire-stampede",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FireStamped.webp",
    alt: "Fire Stampede",
    name: "Fire Stampede",
    providerName: "Vivo",
  },
  fireportals: {
    href: "/casino/pragmaticplay-fire-portals",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FirePortals.webp",
    alt: "Fire Portals",
    name: "Fire Portals",
    providerName: "Vivo",
  },
  firehot5jackpotplay: {
    href: "/casino/pragmaticplay-fire-hot-5-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FireHot5JackpotPlay.webp",
    alt: "Fire Hot 5 Jackpot Play",
    name: "Fire Hot 5 Jackpot Play",
    providerName: "Vivo",
  },
  firehot5: {
    href: "/casino/pragmaticplay-fire-hot-5",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FireHot5.webp",
    alt: "Fire Hot 5",
    name: "Fire Hot 5",
    providerName: "Vivo",
  },
  firehot40jackpotplay: {
    href: "/casino/pragmaticplay-fire-hot-40-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FireHot40JackpotPlay.webp",
    alt: "Fire Hot 40 Jackpot Play",
    name: "Fire Hot 40 Jackpot Play",
    providerName: "Vivo",
  },
  firehot40: {
    href: "/casino/pragmaticplay-fire-hot-40",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FireHot40.webp",
    alt: "Fire Hot 40",
    name: "Fire Hot 40",
    providerName: "Vivo",
  },
  firehot20jackpotplay: {
    href: "/casino/pragmaticplay-fire-hot-20-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FireHot20JackpotPlay.webp",
    alt: "Fire Hot 20 Jackpot Play",
    name: "Fire Hot 20 Jackpot Play",
    providerName: "Vivo",
  },
  firehot20: {
    href: "/casino/pragmaticplay-fire-hot-20",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FireHot20.webp",
    alt: "Fire Hot 20",
    name: "Fire Hot 20",
    providerName: "Vivo",
  },
  firehot100jackpotplay: {
    href: "/casino/pragmaticplay-fire-hot-100-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FireHot100JackpotPla.webp",
    alt: "Fire Hot 100 Jackpot Play",
    name: "Fire Hot 100 Jackpot Play",
    providerName: "Vivo",
  },
  firehot100: {
    href: "/casino/pragmaticplay-fire-hot-100",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FireHot100.webp",
    alt: "Fire Hot 100",
    name: "Fire Hot 100",
    providerName: "Vivo",
  },
  firearcher: {
    href: "/casino/pragmaticplay-fire-archer",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FireArcher.webp",
    alt: "Fire Archer",
    name: "Fire Archer",
    providerName: "Vivo",
  },
  fire88: {
    href: "/casino/pragmaticplay-fire-88",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Fire88.webp",
    alt: "Fire 88",
    name: "Fire 88",
    providerName: "Vivo",
  },
  fingerlicknfreespins: {
    href: "/casino/pragmaticplay-finger-lickn-free-spins",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FingerLicknFreeSpins.webp",
    alt: "Finger Lick'n Free Spins",
    name: "Finger Lick'n Free Spins",
    providerName: "Vivo",
  },
  fiestafortune: {
    href: "/casino/pragmaticplay-fiesta-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FiestaFortune.webp",
    alt: "Fiesta Fortune",
    name: "Fiesta Fortune",
    providerName: "Vivo",
  },
  fiestadesanfermin: {
    href: "/casino/pragmaticplay-fiesta-de-san-fermin",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FiestadeSanFermin.webp",
    alt: "Fiesta de San Fermin",
    name: "Fiesta de San Fermin",
    providerName: "Vivo",
  },
  fatpanda: {
    href: "/casino/pragmaticplay-fat-panda",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FatPanda.webp",
    alt: "Fat Panda",
    name: "Fat Panda",
    providerName: "Vivo",
  },
  fangtasticfreespins: {
    href: "/casino/pragmaticplay-fangtastic-freespins",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FangtasticFreespins.webp",
    alt: "Fangtastic Freespins",
    name: "Fangtastic Freespins",
    providerName: "Vivo",
  },
  fairytalefortune: {
    href: "/casino/pragmaticplay-fairytale-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/FairytaleFortune.webp",
    alt: "Fairytale Fortune",
    name: "Fairytale Fortune",
    providerName: "Vivo",
  },
  eyeofthestorm: {
    href: "/casino/pragmaticplay-eye-of-the-storm",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/EyeoftheStorm.webp",
    alt: "Eye of the Storm",
    name: "Eye of the Storm",
    providerName: "Vivo",
  },
  eyeofspartacus: {
    href: "/casino/pragmaticplay-eye-of-spartacus",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/EyeofSpartacus.webp",
    alt: "Eye of Spartacus",
    name: "Eye of Spartacus",
    providerName: "Vivo",
  },
  eyeofcleopatra: {
    href: "/casino/pragmaticplay-eye-of-cleopatra",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/EyeofCleopatra.webp",
    alt: "Eye of Cleopatra",
    name: "Eye of Cleopatra",
    providerName: "Vivo",
  },
  extrajuicymegaways: {
    href: "/casino/pragmaticplay-extra-juicy-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ExtraJuicyMegaways.webp",
    alt: "Extra Juicy Megaways",
    name: "Extra Juicy Megaways",
    providerName: "Vivo",
  },
  extrajuicy: {
    href: "/casino/pragmaticplay-extra-juicy",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ExtraJuicy.webp",
    alt: "Extra Juicy",
    name: "Extra Juicy",
    providerName: "Vivo",
  },
  excaliburunleashed: {
    href: "/casino/pragmaticplay-excalibur-unleashed",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ExcaliburUnleashed.webp",
    alt: "Excalibur Unleashed",
    name: "Excalibur Unleashed",
    providerName: "Vivo",
  },
  eternalempressfreezetime: {
    href: "/casino/pragmaticplay-eternal-empress-freeze-time",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/EternalEmpressFreezeTime.webp",
    alt: "Eternal Empress - Freeze Time",
    name: "Eternal Empress - Freeze Time",
    providerName: "Vivo",
  },
  escapethepyramidfireice: {
    href: "/casino/pragmaticplay-escape-the-pyramid-fire-and-ice",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/EscapethePyramidFire&Ice.webp",
    alt: "Escape the Pyramid Fire & Ice",
    name: "Escape the Pyramid Fire & Ice",
    providerName: "Vivo",
  },
  emptythebank: {
    href: "/casino/pragmaticplay-empty-the-bank",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/EmptytheBank.webp",
    alt: "Empty the Bank",
    name: "Empty the Bank",
    providerName: "Vivo",
  },
  emperorcaishen: {
    href: "/casino/pragmaticplay-emperor-caishen",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/EmperorCaishen.webp",
    alt: "Emperor Caishen",
    name: "Emperor Caishen",
    providerName: "Vivo",
  },
  emeraldkingrainbowroad: {
    href: "/casino/pragmaticplay-emerald-king-rainbow-road",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/EmeraldKingRainbowRoad.webp",
    alt: "Emerald King Rainbow Road",
    name: "Emerald King Rainbow Road",
    providerName: "Vivo",
  },
  emeraldking: {
    href: "/casino/pragmaticplay-emerald-king",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/EmeraldKing.webp",
    alt: "Emerald King",
    name: "Emerald King",
    providerName: "Vivo",
  },
  elementalgemsmegaways: {
    href: "/casino/pragmaticplay-elemental-gems-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ElementalGemsMegaways.webp",
    alt: "Elemental Gems Megaways",
    name: "Elemental Gems Megaways",
    providerName: "Vivo",
  },
  eldoradothecityofgold: {
    href: "/casino/pragmaticplay-el-dorado-the-city-of-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ElDoradoTheCityofGold.webp",
    alt: "El Dorado The City of Gold",
    name: "El Dorado The City of Gold",
    providerName: "Vivo",
  },
  egyptianfortunes: {
    href: "/casino/pragmaticplay-egyptian-fortunes",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/EgyptianFortunes.webp",
    alt: "Egyptian Fortunes",
    name: "Egyptian Fortunes",
    providerName: "Vivo",
  },
  egyptbonanza: {
    href: "/casino/pragmaticplay-egypt-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/EgyptBonanza.webp",
    alt: "Egypt Bonanza",
    name: "Egypt Bonanza",
    providerName: "Vivo",
  },
  eggrushjackpotplay: {
    href: "/casino/pragmaticplay-egg-rush-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/EggRushJackpotPlay.webp",
    alt: "Egg Rush Jackpot Play",
    name: "Egg Rush Jackpot Play",
    providerName: "Vivo",
  },
  dynamitediggindoug: {
    href: "/casino/pragmaticplay-dynamite-diggin-doug",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/DynamiteDigginDoug.webp",
    alt: "Dynamite Diggin Doug",
    name: "Dynamite Diggin Doug",
    providerName: "Vivo",
  },
  dwarvengolddeluxe: {
    href: "/casino/pragmaticplay-dwarven-gold-deluxe",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/DwarvenGoldDeluxe.webp",
    alt: "Dwarven Gold Deluxe",
    name: "Dwarven Gold Deluxe",
    providerName: "Vivo",
  },
  dwarfdragon: {
    href: "/casino/pragmaticplay-dwarf-and-dragon",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Dwarf&Dragon.webp",
    alt: "Dwarf & Dragon",
    name: "Dwarf & Dragon",
    providerName: "Vivo",
  },
  drillthatgold: {
    href: "/casino/pragmaticplay-drill-that-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/DrillthatGold.webp",
    alt: "Drill that Gold",
    name: "Drill that Gold",
    providerName: "Vivo",
  },
  dragonkingdomeyesoffire: {
    href: "/casino/pragmaticplay-dragon-kingdom-eyes-of-fire",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/DragonKingdomEyesofFire.webp",
    alt: "Dragon Kingdom Eyes of Fire",
    name: "Dragon Kingdom Eyes of Fire",
    providerName: "Vivo",
  },
  dragonkingdom: {
    href: "/casino/pragmaticplay-dragon-kingdom",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/DragonKingdom.webp",
    alt: "Dragon Kingdom",
    name: "Dragon Kingdom",
    providerName: "Vivo",
  },
  dragonkinghotpots: {
    href: "/casino/pragmaticplay-dragon-king-hot-pots",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/DragonKingHotPots.webp",
    alt: "Dragon King Hot Pots",
    name: "Dragon King Hot Pots",
    providerName: "Vivo",
  },
  dragonhotholdandspin: {
    href: "/casino/pragmaticplay-dragon-hot-hold-and-spin",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/DragonHotHoldandSpin.webp",
    alt: "Dragon Hot Hold and Spin",
    name: "Dragon Hot Hold and Spin",
    providerName: "Vivo",
  },
  dragonhero: {
    href: "/casino/pragmaticplay-dragon-hero",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/DragonHero.webp",
    alt: "Dragon Hero",
    name: "Dragon Hero",
    providerName: "Vivo",
  },
  dragongold88: {
    href: "/casino/pragmaticplay-dragon-gold-88",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/DragonGold88.webp",
    alt: "Dragon Gold 88",
    name: "Dragon Gold 88",
    providerName: "Vivo",
  },
  dragojewelsoffortune: {
    href: "/casino/pragmaticplay-drago-jewels-of-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/DragoJewelsofFortune.webp",
    alt: "Drago  Jewels of Fortune",
    name: "Drago  Jewels of Fortune",
    providerName: "Vivo",
  },
  downtherails: {
    href: "/casino/pragmaticplay-down-the-rails",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/DowntheRails.webp",
    alt: "Down the Rails",
    name: "Down the Rails",
    providerName: "Vivo",
  },
  discolady: {
    href: "/casino/pragmaticplay-disco-lady",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/DiscoLady.webp",
    alt: "Disco Lady",
    name: "Disco Lady",
    providerName: "Vivo",
  },
  dinodrop: {
    href: "/casino/pragmaticplay-dino-drop",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/DinoDrop.webp",
    alt: "Dino Drop",
    name: "Dino Drop",
    providerName: "Vivo",
  },
  diamondstrike: {
    href: "/casino/pragmaticplay-diamond-strike",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/DiamondStrike.webp",
    alt: "Diamond Strike",
    name: "Diamond Strike",
    providerName: "Vivo",
  },
  devilicious: {
    href: "/casino/pragmaticplay-devilicious",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Devilicious.webp",
    alt: "Devilicious",
    name: "Devilicious",
    providerName: "Vivo",
  },
  deviljoker: {
    href: "/casino/pragmaticplay-devil-joker",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/DevilJoker.webp",
    alt: "Devil Joker",
    name: "Devil Joker",
    providerName: "Vivo",
  },
  dayofdead: {
    href: "/casino/pragmaticplay-day-of-dead",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/DayofDead.webp",
    alt: "Day of Dead",
    name: "Day of Dead",
    providerName: "Vivo",
  },
  danielnegreanusfishbuffet: {
    href: "/casino/pragmaticplay-daniel-negreanus-fish-buffet",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/DanielNegreanusFishBuffet.webp",
    alt: "Daniel Negreanu's Fish Buffet",
    name: "Daniel Negreanu's Fish Buffet",
    providerName: "Vivo",
  },
  danceparty: {
    href: "/casino/pragmaticplay-dance-party",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/DanceParty.webp",
    alt: "Dance Party",
    name: "Dance Party",
    providerName: "Vivo",
  },
  davincistreasure: {
    href: "/casino/pragmaticplay-da-vincis-treasure",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/DaVincisTreasure.webp",
    alt: "Da Vincis Treasure",
    name: "Da Vincis Treasure",
    providerName: "Vivo",
  },
  cyberheist: {
    href: "/casino/pragmaticplay-cyber-heist",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CyberHeist.webp",
    alt: "Cyber Heist",
    name: "Cyber Heist",
    providerName: "Vivo",
  },
  curseofthewerewolfmegaways: {
    href: "/casino/pragmaticplay-curse-of-the-werewolf-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CurseoftheWerewolfMegaways.webp",
    alt: "Curse of the Werewolf Megaways",
    name: "Curse of the Werewolf Megaways",
    providerName: "Vivo",
  },
  crystalcavernsmegaways: {
    href: "/casino/pragmaticplay-crystal-caverns-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CrystalCavernsMegaways.webp",
    alt: "Crystal Caverns Megaways",
    name: "Crystal Caverns Megaways",
    providerName: "Vivo",
  },
  crownoffirejackpotplay: {
    href: "/casino/pragmaticplay-crown-of-fire-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/crownoffirejackpotplays.webp",
    alt: "Crown of Fire Jackpot Play",
    name: "Crown of Fire Jackpot Play",
    providerName: "Vivo",
  },
  crazy7s: {
    href: "/casino/pragmaticplay-crazy-7s",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Crazy7s.webp",
    alt: "Crazy 7s",
    name: "Crazy 7s",
    providerName: "Vivo",
  },
  crankitup: {
    href: "/casino/pragmaticplay-crank-it-up",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CrankItUp.webp",
    alt: "Crank It Up",
    name: "Crank It Up",
    providerName: "Vivo",
  },
  cowboysgold: {
    href: "/casino/pragmaticplay-cowboys-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CowboysGold.webp",
    alt: "Cowboys Gold",
    name: "Cowboys Gold",
    providerName: "Vivo",
  },
  cowboycoins: {
    href: "/casino/pragmaticplay-cowboy-coins",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CowboyCoins.webp",
    alt: "Cowboy Coins",
    name: "Cowboy Coins",
    providerName: "Vivo",
  },
  countryfarming: {
    href: "/casino/pragmaticplay-country-farming",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CountryFarming.webp",
    alt: "Country Farming",
    name: "Country Farming",
    providerName: "Vivo",
  },
  cosmolotbonanza: {
    href: "/casino/pragmaticplay-cosmolot-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CosmolotBonanza.webp",
    alt: "Cosmolot Bonanza",
    name: "Cosmolot Bonanza",
    providerName: "Vivo",
  },
  cosmiccash: {
    href: "/casino/pragmaticplay-cosmic-cash",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CosmicCash.webp",
    alt: "Cosmic Cash",
    name: "Cosmic Cash",
    providerName: "Vivo",
  },
  coralriches: {
    href: "/casino/pragmaticplay-coral-riches",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CoralRiches.webp",
    alt: "Coral Riches",
    name: "Coral Riches",
    providerName: "Vivo",
  },
  congocashxl: {
    href: "/casino/pragmaticplay-congo-cash-xl",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CongoCashXL.webp",
    alt: "Congo Cash XL",
    name: "Congo Cash XL",
    providerName: "Vivo",
  },
  congocash: {
    href: "/casino/pragmaticplay-congo-cash",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CongoCash.webp",
    alt: "Congo Cash",
    name: "Congo Cash",
    providerName: "Vivo",
  },
  colossalcashzone: {
    href: "/casino/pragmaticplay-colossal-cash-zone",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ColossalCashZone.webp",
    alt: "Colossal Cash Zone",
    name: "Colossal Cash Zone",
    providerName: "Vivo",
  },
  coffeewild: {
    href: "/casino/pragmaticplay-coffee-wild",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CoffeeWild.webp",
    alt: "Coffee Wild",
    name: "Coffee Wild",
    providerName: "Vivo",
  },
  clubtropicanahappyhour: {
    href: "/casino/pragmaticplay-club-tropicana-happy-hour",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ClubTropicanaHappyHour.webp",
    alt: "Club Tropicana Happy Hour",
    name: "Club Tropicana Happy Hour",
    providerName: "Vivo",
  },
  clubtropicana: {
    href: "/casino/pragmaticplay-club-tropicana",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ClubTropicana.webp",
    alt: "Club Tropicana",
    name: "Club Tropicana",
    providerName: "Vivo",
  },
  clovergold: {
    href: "/casino/pragmaticplay-clover-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CloverGold.webp",
    alt: "Clover Gold",
    name: "Clover Gold",
    providerName: "Vivo",
  },
  cleocatra: {
    href: "/casino/pragmaticplay-cleocatra",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Cleocatra.webp",
    alt: "Cleocatra",
    name: "Cleocatra",
    providerName: "Vivo",
  },
  christmascarolmegaways: {
    href: "/casino/pragmaticplay-christmas-carol-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ChristmasCarolMegaways.webp",
    alt: "Christmas Carol Megaways",
    name: "Christmas Carol Megaways",
    providerName: "Vivo",
  },
  christmasbigbassbonanza: {
    href: "/casino/pragmaticplay-christmas-big-bass-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ChristmasBigBassBonanza.webp",
    alt: "Christmas Big Bass Bonanza",
    name: "Christmas Big Bass Bonanza",
    providerName: "Vivo",
  },
  chilliheatspicyspins: {
    href: "/casino/pragmaticplay-chilli-heat-spicy-spins",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ChilliHeatSpicySpins.webp",
    alt: "Chilli Heat Spicy Spins",
    name: "Chilli Heat Spicy Spins",
    providerName: "Vivo",
  },
  chilliheatmegaways: {
    href: "/casino/pragmaticplay-chilli-heat-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ChilliHeatMegaways.webp",
    alt: "Chilli Heat Megaways",
    name: "Chilli Heat Megaways",
    providerName: "Vivo",
  },
  chilliheat: {
    href: "/casino/pragmaticplay-chilli-heat",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ChilliHeat.webp",
    alt: "Chilli Heat",
    name: "Chilli Heat",
    providerName: "Vivo",
  },
  chickendrop: {
    href: "/casino/pragmaticplay-chicken-drop",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ChickenDrop.webp",
    alt: "Chicken Drop",
    name: "Chicken Drop",
    providerName: "Vivo",
  },
  chickenchase: {
    href: "/casino/pragmaticplay-chicken-chase",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ChickenChase.webp",
    alt: "Chicken Chase",
    name: "Chicken Chase",
    providerName: "Vivo",
  },
  chestsofcaishen: {
    href: "/casino/pragmaticplay-chests-of-cai-shen",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/ChestsofCaiShen.webp",
    alt: "Chests of Cai Shen",
    name: "Chests of Cai Shen",
    providerName: "Vivo",
  },
  cheekyemperor: {
    href: "/casino/pragmaticplay-cheeky-emperor",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CheekyEmperor.webp",
    alt: "Cheeky Emperor",
    name: "Cheeky Emperor",
    providerName: "Vivo",
  },
  castleoffire: {
    href: "/casino/pragmaticplay-castle-of-fire",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CastleofFire.webp",
    alt: "Castle of Fire",
    name: "Castle of Fire",
    providerName: "Vivo",
  },
  cashpatrol: {
    href: "/casino/pragmaticplay-cash-patrol",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CashPatrol.webp",
    alt: "Cash Patrol",
    name: "Cash Patrol",
    providerName: "Vivo",
  },
  cashchips: {
    href: "/casino/pragmaticplay-cash-chips",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CashChips.webp",
    alt: "Cash Chips",
    name: "Cash Chips",
    providerName: "Vivo",
  },
  cashbonanza: {
    href: "/casino/pragmaticplay-cash-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CashBonanza.webp",
    alt: "Cash Bonanza",
    name: "Cash Bonanza",
    providerName: "Vivo",
  },
  cappadocia: {
    href: "/casino/pragmaticplay-cappadocia",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Cappadocia.webp",
    alt: "Cappadocia",
    name: "Cappadocia",
    providerName: "Vivo",
  },
  candyvillage: {
    href: "/casino/pragmaticplay-candy-village",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CandyVillage.webp",
    alt: "Candy Village",
    name: "Candy Village",
    providerName: "Vivo",
  },
  candystars: {
    href: "/casino/pragmaticplay-candy-stars",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CandyStars.webp",
    alt: "Candy Stars",
    name: "Candy Stars",
    providerName: "Vivo",
  },
  candyjarclusters: {
    href: "/casino/pragmaticplay-candy-jar-clusters",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CandyJarClusters.webp",
    alt: "Candy Jar Clusters",
    name: "Candy Jar Clusters",
    providerName: "Vivo",
  },
  candycorner: {
    href: "/casino/pragmaticplay-candy-corner",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CandyCorner.webp",
    alt: "Candy Corner",
    name: "Candy Corner",
    providerName: "Vivo",
  },
  candyblitzbombs: {
    href: "/casino/pragmaticplay-candy-blitz-bombs",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CandyBlitzBombs.webp",
    alt: "Candy Blitz Bombs",
    name: "Candy Blitz Bombs",
    providerName: "Vivo",
  },
  candyblitz: {
    href: "/casino/pragmaticplay-candy-blitz",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CandyBlitz.webp",
    alt: "Candy Blitz",
    name: "Candy Blitz",
    providerName: "Vivo",
  },
  caishensgold: {
    href: "/casino/pragmaticplay-caishens-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CaishensGold.webp",
    alt: "Caishens Gold",
    name: "Caishens Gold",
    providerName: "Vivo",
  },
  caishensgemsjackpotplay: {
    href: "/casino/pragmaticplay-caishens-gems-jackpot-play",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CaishensGemsJackpotPlay.webp",
    alt: "Caishen's Gems Jackpot Play",
    name: "Caishen's Gems Jackpot Play",
    providerName: "Vivo",
  },
  caishenscash: {
    href: "/casino/pragmaticplay-caishens-cash",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/CaishensCash.webp",
    alt: "Caishens Cash",
    name: "Caishens Cash",
    providerName: "Vivo",
  },
  busybees: {
    href: "/casino/pragmaticplay-busy-bees",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BusyBees.webp",
    alt: "Busy Bees",
    name: "Busy Bees",
    providerName: "Vivo",
  },
  bullfiesta: {
    href: "/casino/pragmaticplay-bull-fiesta",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BullFiesta.webp",
    alt: "Bull Fiesta",
    name: "Bull Fiesta",
    providerName: "Vivo",
  },
  buffalokinguntamedmegaways: {
    href: "/casino/pragmaticplay-buffalo-king-untamed-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BuffaloKingUntamedMegaway.webp",
    alt: "Buffalo King Untamed Megaways",
    name: "Buffalo King Untamed Megaways",
    providerName: "Vivo",
  },
  buffalokingmegaways: {
    href: "/casino/pragmaticplay-buffalo-king-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BuffaloKingMegaways.webp",
    alt: "Buffalo King Megaways",
    name: "Buffalo King Megaways",
    providerName: "Vivo",
  },
  buffaloking: {
    href: "/casino/pragmaticplay-buffalo-king",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BuffaloKing.webp",
    alt: "Buffalo King",
    name: "Buffalo King",
    providerName: "Vivo",
  },
  bubblewild2: {
    href: "/casino/pragmaticplay-bubble-wild-2",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BubbleWild2.webp",
    alt: "Bubble Wild 2",
    name: "Bubble Wild 2",
    providerName: "Vivo",
  },
  bubblewild: {
    href: "/casino/pragmaticplay-bubble-wild",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BubbleWild.webp",
    alt: "Bubble Wild",
    name: "Bubble Wild",
    providerName: "Vivo",
  },
  bubblepop: {
    href: "/casino/pragmaticplay-bubble-pop",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BubblePop.webp",
    alt: "Bubble Pop",
    name: "Bubble Pop",
    providerName: "Vivo",
  },
  brickhousebonanza: {
    href: "/casino/pragmaticplay-brick-house-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BrickHouseBonanza.webp",
    alt: "Brick House Bonanza",
    name: "Brick House Bonanza",
    providerName: "Vivo",
  },
  bowofartemis: {
    href: "/casino/pragmaticplay-bow-of-artemis",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BowofArtemis.webp",
    alt: "Bow of Artemis",
    name: "Bow of Artemis",
    providerName: "Vivo",
  },
  bountygold: {
    href: "/casino/pragmaticplay-bounty-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BountyGold.webp",
    alt: "Bounty Gold",
    name: "Bounty Gold",
    providerName: "Vivo",
  },
  bookofvikings: {
    href: "/casino/pragmaticplay-book-of-vikings",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BookofVikings.webp",
    alt: "Book of Vikings",
    name: "Book of Vikings",
    providerName: "Vivo",
  },
  bookofthefallen: {
    href: "/casino/pragmaticplay-book-of-the-fallen",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BookoftheFallen.webp",
    alt: "Book of the Fallen",
    name: "Book of the Fallen",
    providerName: "Vivo",
  },
  bookofsports: {
    href: "/casino/pragmaticplay-book-of-sports",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/bookofsports.webp",
    alt: "Book of Sports",
    name: "Book of Sports",
    providerName: "Vivo",
  },
  bookofkingdoms: {
    href: "/casino/pragmaticplay-book-of-kingdoms",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BookofKingdoms.webp",
    alt: "Book of Kingdoms",
    name: "Book of Kingdoms",
    providerName: "Vivo",
  },
  bookofgoldensands: {
    href: "/casino/pragmaticplay-book-of-golden-sands",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BookofGoldenSands.webp",
    alt: "Book of Golden Sands",
    name: "Book of Golden Sands",
    providerName: "Vivo",
  },
  bookofeldorado: {
    href: "/casino/pragmaticplay-book-of-el-dorado",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BookofElDorado.webp",
    alt: "Book of El Dorado",
    name: "Book of El Dorado",
    providerName: "Vivo",
  },
  bookofaztecking: {
    href: "/casino/pragmaticplay-book-of-aztec-king",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BookofAztecKing.webp",
    alt: "Book of Aztec King",
    name: "Book of Aztec King",
    providerName: "Vivo",
  },
  bonanzagold: {
    href: "/casino/pragmaticplay-bonanza-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BonanzaGold.webp",
    alt: "Bonanza Gold",
    name: "Bonanza Gold",
    providerName: "Vivo",
  },
  bombbonanza: {
    href: "/casino/pragmaticplay-bomb-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BombBonanza.webp",
    alt: "Bomb Bonanza",
    name: "Bomb Bonanza",
    providerName: "Vivo",
  },
  blitzsuperwheel: {
    href: "/casino/pragmaticplay-blitz-super-wheel",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BlitzSuperWheel.webp",
    alt: "Blitz Super Wheel",
    name: "Blitz Super Wheel",
    providerName: "Vivo",
  },
  blazingwildsmegaways: {
    href: "/casino/pragmaticplay-blazing-wilds-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BlazingWildsMegaways.webp",
    alt: "Blazing Wilds Megaways",
    name: "Blazing Wilds Megaways",
    providerName: "Vivo",
  },
  bladefangs: {
    href: "/casino/pragmaticplay-blade-and-fangs",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BladeFangs.webp",
    alt: "Blade & Fangs",
    name: "Blade & Fangs",
    providerName: "Vivo",
  },
  blackbull: {
    href: "/casino/pragmaticplay-black-bull",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BlackBull.webp",
    alt: "Black Bull",
    name: "Black Bull",
    providerName: "Vivo",
  },
  bisonspirit: {
    href: "/casino/pragmaticplay-bison-spirit",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BisonSpirit.webp",
    alt: "Bison Spirit",
    name: "Bison Spirit",
    providerName: "Vivo",
  },
  bisonblaze: {
    href: "/casino/pragmaticplay-bison-blaze",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/bisonblaze.webp",
    alt: "Bison Blaze",
    name: "Bison Blaze",
    providerName: "Vivo",
  },
  biggerbasssplash: {
    href: "/casino/pragmaticplay-bigger-bass-splash",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BiggerBassSplash.webp",
    alt: "Bigger Bass Splash",
    name: "Bigger Bass Splash",
    providerName: "Vivo",
  },
  biggerbassbonanza: {
    href: "/casino/pragmaticplay-bigger-bass-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BiggerBassBonanza.webp",
    alt: "Bigger Bass Bonanza",
    name: "Bigger Bass Bonanza",
    providerName: "Vivo",
  },
  biggerbassblizzardchristmascatch: {
    href: "/casino/pragmaticplay-bigger-bass-blizzard-christmas-catch",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BiggerBassBlizzardChristmasCatch.webp",
    alt: "Bigger Bass Blizzard  Christmas Catch",
    name: "Bigger Bass Blizzard  Christmas Catch",
    providerName: "Vivo",
  },
  bigjuan: {
    href: "/casino/pragmaticplay-big-juan",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BigJuan.webp",
    alt: "Big Juan",
    name: "Big Juan",
    providerName: "Vivo",
  },
  bigburgerloaditupwithxtracheese: {
    href: "/casino/pragmaticplay-big-burger-load-it-up-with-xtra-cheese",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BigBurgerLoaditupwithXtraCheese.webp",
    alt: "Big Burger Load it up with Xtra Cheese",
    name: "Big Burger Load it up with Xtra Cheese",
    providerName: "Vivo",
  },
  bigbassxmasextreme: {
    href: "/casino/pragmaticplay-big-bass-xmas-extreme",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BigBassXmasExtreme.webp",
    alt: "Big Bass Xmas Extreme",
    name: "Big Bass Xmas Extreme",
    providerName: "Vivo",
  },
  bigbassvegasdoubledowndeluxe: {
    href: "/casino/pragmaticplay-big-bass-vegas-double-down-deluxe",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BigBassVegasDoubleDownDeluxe.webp",
    alt: "Big Bass Vegas Double Down Deluxe",
    name: "Big Bass Vegas Double Down Deluxe",
    providerName: "Vivo",
  },

  bigbassholdspinnermegaways: {
    href: "/casino/pragmaticplay-big-bass-hold-and-spinner-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BigBassHold&SpinnerMegaways.webp",
    alt: "Big Bass Hold & Spinner Megaways",
    name: "Big Bass Hold & Spinner Megaways",
    providerName: "Vivo",
  },
  bigbasshalloween2: {
    href: "/casino/pragmaticplay-big-bass-halloween-2",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BigBassHalloween2.webp",
    alt: "Big Bass Halloween 2",
    name: "Big Bass Halloween 2",
    providerName: "Vivo",
  },

  bigbassfloatsmyboat: {
    href: "/casino/pragmaticplay-big-bass-floats-my-boat",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BigBassFloatsmyBoat.webp",
    alt: "Big Bass Floats my Boat",
    name: "Big Bass Floats my Boat",
    providerName: "Vivo",
  },
  bigbassdice: {
    href: "/casino/pragmaticplay-big-bass-dice",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BigBassDice.webp",
    alt: "Big Bass Dice",
    name: "Big Bass Dice",
    providerName: "Vivo",
  },
  bigbassdayattheraces: {
    href: "/casino/pragmaticplay-big-bass-day-at-the-races",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BigBassDayattheRaces.webp",
    alt: "Big Bass Day at the Races",
    name: "Big Bass Day at the Races",
    providerName: "Vivo",
  },
  bigbasschristmasbash: {
    href: "/casino/pragmaticplay-big-bass-christmas-bash",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BigBassChristmasBash.webp",
    alt: "Big Bass Christmas Bash",
    name: "Big Bass Christmas Bash",
    providerName: "Vivo",
  },
  bigbassboxingbonusround: {
    href: "/casino/pragmaticplay-big-bass-boxing-bonus-round",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BigBassBoxingBonusRound.webp",
    alt: "Big Bass Boxing Bonus Round",
    name: "Big Bass Boxing Bonus Round",
    providerName: "Vivo",
  },
  bigbassbonanzamegaways: {
    href: "/casino/pragmaticplay-big-bass-bonanza-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BigBassBonanzaMegaways.webp",
    alt: "Big Bass Bonanza Megaways",
    name: "Big Bass Bonanza Megaways",
    providerName: "Vivo",
  },
  bigbassbonanza3reeler: {
    href: "/casino/pragmaticplay-big-bass-bonanza-3-reeler",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BigBassBonanza3Reeler.webp",
    alt: "Big Bass Bonanza 3 Reeler",
    name: "Big Bass Bonanza 3 Reeler",
    providerName: "Vivo",
  },
  bigbassbonanza1000: {
    href: "/casino/pragmaticplay-big-bass-bonanza-1000",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BigBassBonanza1000.webp",
    alt: "Big Bass Bonanza 1000",
    name: "Big Bass Bonanza 1000",
    providerName: "Vivo",
  },
  bigbassbonanzareelaction: {
    href: "/casino/pragmaticplay-big-bass-bonanza-reel-action",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BigBassBonanzaReelAction.webp",
    alt: "Big Bass Bonanza - Reel Action",
    name: "Big Bass Bonanza - Reel Action",
    providerName: "Vivo",
  },

  bigbassamazonxtreme: {
    href: "/casino/pragmaticplay-big-bass-amazon-xtreme",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BigBassAmazonXtreme.webp",
    alt: "Big Bass Amazon Xtreme",
    name: "Big Bass Amazon Xtreme",
    providerName: "Vivo",
  },
  bigbasskeepingitreel: {
    href: "/casino/pragmaticplay-big-bass-keeping-it-reel",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BigBassKeepingitReel.webp",
    alt: "Big Bass Keeping it Reel",
    name: "Big Bass Keeping it Reel",
    providerName: "Vivo",
  },
  bigbassholdspinner: {
    href: "/casino/pragmaticplay-big-bass-hold-and-spinner",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BigBassHold&Spinner.webp",
    alt: "Big Bass Hold & Spinner",
    name: "Big Bass Hold & Spinner",
    providerName: "Vivo",
  },
  beowulf: {
    href: "/casino/pragmaticplay-beowulf",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Beowulf.webp",
    alt: "Beowulf",
    name: "Beowulf",
    providerName: "Vivo",
  },
  barnyardmegahaysmegaways: {
    href: "/casino/pragmaticplay-barnyard-megahays-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BarnyardMegahaysMegaways.webp",
    alt: "Barnyard Megahays Megaways",
    name: "Barnyard Megahays Megaways",
    providerName: "Vivo",
  },
  barnfestival: {
    href: "/casino/pragmaticplay-barn-festival",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BarnFestival.webp",
    alt: "Barn Festival",
    name: "Barn Festival",
    providerName: "Vivo",
  },
  barbar: {
    href: "/casino/pragmaticplay-barbar",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Barbar.webp",
    alt: "Barbar",
    name: "Barbar",
    providerName: "Vivo",
  },
  banditmegaways: {
    href: "/casino/pragmaticplay-bandit-megawaystm",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BanditMegaways.webp",
    alt: "Bandit Megaways",
    name: "Bandit Megaways",
    providerName: "Vivo",
  },
  balidragon: {
    href: "/casino/pragmaticplay-bali-dragon",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BaliDragon.webp",
    alt: "Bali Dragon",
    name: "Bali Dragon",
    providerName: "Vivo",
  },
  badgeblitz: {
    href: "/casino/pragmaticplay-badge-blitz",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/BadgeBlitz.webp",
    alt: "Badge Blitz",
    name: "Badge Blitz",
    providerName: "Vivo",
  },
  aztectreasurehunt: {
    href: "/casino/pragmaticplay-aztec-treasure-hunt",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/AztecTreasureHunt.webp",
    alt: "Aztec Treasure Hunt",
    name: "Aztec Treasure Hunt",
    providerName: "Vivo",
  },
  aztectreasure: {
    href: "/casino/pragmaticplay-aztec-treasure",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/AztecTreasure.webp",
    alt: "Aztec Treasure",
    name: "Aztec Treasure",
    providerName: "Vivo",
  },
  aztecsmash: {
    href: "/casino/pragmaticplay-aztec-smash",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/AztecSmash.webp",
    alt: "Aztec Smash",
    name: "Aztec Smash",
    providerName: "Vivo",
  },
  aztecpowernudge: {
    href: "/casino/pragmaticplay-aztec-powernudge",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/AztecPowernudge.webp",
    alt: "Aztec Powernudge",
    name: "Aztec Powernudge",
    providerName: "Vivo",
  },
  azteckingmegaways: {
    href: "/casino/pragmaticplay-aztec-king-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/AztecKingMegaways.webp",
    alt: "Aztec King Megaways",
    name: "Aztec King Megaways",
    providerName: "Vivo",
  },
  aztecking: {
    href: "/casino/pragmaticplay-aztec-king",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/AztecKing.webp",
    alt: "Aztec King",
    name: "Aztec King",
    providerName: "Vivo",
  },
  aztecgemsmegaways: {
    href: "/casino/pragmaticplay-aztec-gems-megawaystm",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/AztecGemsMegaways.webp",
    alt: "Aztec Gems Megaways",
    name: "Aztec Gems Megaways",
    providerName: "Vivo",
  },
  aztecgemsdeluxe: {
    href: "/casino/pragmaticplay-aztec-gems-deluxe",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/AztecGemsDeluxe.webp",
    alt: "Aztec Gems Deluxe",
    name: "Aztec Gems Deluxe",
    providerName: "Vivo",
  },
  aztecgems: {
    href: "/casino/pragmaticplay-aztec-gems",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/AztecGems.webp",
    alt: "Aztec Gems",
    name: "Aztec Gems",
    providerName: "Vivo",
  },
  aztecbonanza: {
    href: "/casino/pragmaticplay-aztec-bonanza",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/AztecBonanza.webp",
    alt: "Aztec Bonanza",
    name: "Aztec Bonanza",
    providerName: "Vivo",
  },
  aztecblaze: {
    href: "/casino/pragmaticplay-aztec-blaze",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/AztecBlaze.webp",
    alt: "Aztec Blaze",
    name: "Aztec Blaze",
    providerName: "Vivo",
  },
  atlanticmoneymouse: {
    href: "/casino/pragmaticplay-atlantic-money-mouse",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/AtlanticMoneyMouse.webp",
    alt: "Atlantic Money Mouse",
    name: "Atlantic Money Mouse",
    providerName: "Vivo",
  },
  asgard: {
    href: "/casino/pragmaticplay-asgard",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Asgard.webp",
    alt: "Asgard",
    name: "Asgard",
    providerName: "Vivo",
  },
  argonauts: {
    href: "/casino/pragmaticplay-argonauts",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/Argonauts.webp",
    alt: "Argonauts",
    name: "Argonauts",
    providerName: "Vivo",
  },
  angelvssinner: {
    href: "/casino/pragmaticplay-angel-vs-sinner",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/AngelvsSinner.webp",
    alt: "Angel vs Sinner",
    name: "Angel vs Sinner",
    providerName: "Vivo",
  },
  ancientislandmegaways: {
    href: "/casino/pragmaticplay-ancient-island-megawaystm",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/AncientIslandMegaways.webp",
    alt: "Ancient Island Megaways",
    name: "Ancient Island Megaways",
    providerName: "Vivo",
  },
  ancientegyptclassic: {
    href: "/casino/pragmaticplay-ancient-egypt-classic",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/AncientEgyptClassic.webp",
    alt: "Ancient Egypt Classic",
    name: "Ancient Egypt Classic",
    providerName: "Vivo",
  },
  ancientegypt: {
    href: "/casino/pragmaticplay-ancient-egypt",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/AncientEgypt.webp",
    alt: "Ancient Egypt",
    name: "Ancient Egypt",
    providerName: "Vivo",
  },
  alieninvaders: {
    href: "/casino/pragmaticplay-alien-invaders",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/AlienInvaders.webp",
    alt: "Alien Invaders",
    name: "Alien Invaders",
    providerName: "Vivo",
  },
  aladdinandthesorcerer: {
    href: "/casino/pragmaticplay-alien-invaders",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/AladdinandtheSorcerer.webp",
    alt: "Aladdin and the Sorcerer",
    name: "Aladdin and the Sorcerer",
    providerName: "Vivo",
  },
  gold888: {
    href: "/casino/pragmaticplay-888-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/888Gold.webp",
    alt: "888 Gold",
    name: "888 Gold",
    providerName: "Vivo",
  },
  dragons888: {
    href: "/casino/pragmaticplay-888-dragons",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/888Dragons.webp",
    alt: "888 Dragons",
    name: "888 Dragons",
    providerName: "Vivo",
  },
  goldendragonchallenge8: {
    href: "/casino/pragmaticplay-8-golden-dragon-challenge",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/8GoldenDragonChallenge.webp",
    alt: "8 Golden Dragon Challenge",
    name: "8 Golden Dragon Challenge",
    providerName: "Vivo",
  },
  dragons8: {
    href: "/casino/pragmaticplay-8-dragons",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/8Dragons.webp",
    alt: "8 Dragons",
    name: "8 Dragons",
    providerName: "Vivo",
  },
  piggies7: {
    href: "/casino/pragmaticplay-7-piggies",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/7Piggies.webp",
    alt: "7 Piggies",
    name: "7 Piggies",
    providerName: "Vivo",
  },
  monkeys7: {
    href: "/casino/pragmaticplay-7-monkeys",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/7Monkeys.webp",
    alt: "7 Monkeys",
    name: "7 Monkeys",
    providerName: "Vivo",
  },
  cloversoffortune7: {
    href: "/casino/pragmaticplay-7-clovers-of-fortune",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/7CloversofFortune.webp",
    alt: "7 Clovers of Fortune",
    name: "7 Clovers of Fortune",
    providerName: "Vivo",
  },
  jokers6: {
    href: "/casino/pragmaticplay-6-jokers",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/6Jokers.webp",
    alt: "6 Jokers",
    name: "6 Jokers",
    providerName: "Vivo",
  },
  rabbitsmegaways5: {
    href: "/casino/pragmaticplay-5-rabbits-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/5RabbitsMegaways.webp",
    alt: "5 Rabbits Megaways",
    name: "5 Rabbits Megaways",
    providerName: "Vivo",
  },
  lionsmegaways5: {
    href: "/casino/pragmaticplay-5-lions-megaways",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/5LionsMegaways.webp",
    alt: "5 Lions Megaways",
    name: "5 Lions Megaways",
    providerName: "Vivo",
  },
  lionsdance5: {
    href: "/casino/pragmaticplay-5-lions-dance",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/5LionsDance.webp",
    alt: "5 Lions Dance",
    name: "5 Lions Dance",
    providerName: "Vivo",
  },
  lions5: {
    href: "/casino/pragmaticplay-5-lions",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/5Lions.webp",
    alt: "5 Lions",
    name: "5 Lions",
    providerName: "Vivo",
  },
  lionsgold5: {
    href: "/casino/pragmaticplay-5-lions-gold",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/5LionsGold.webp",
    alt: "5 Lions Gold",
    name: "5 Lions Gold",
    providerName: "Vivo",
  },
  geniewishes3: {
    href: "/casino/pragmaticplay-3-genie-wishes",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/3GenieWishes.webp",
    alt: "3 Genie Wishes",
    name: "3 Genie Wishes",
    providerName: "Vivo",
  },
  dancingmonkeys3: {
    href: "/casino/pragmaticplay-3-dancing-monkeys",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/3DancingMonkeys.webp",
    alt: "3 Dancing Monkeys",
    name: "3 Dancing Monkeys",
    providerName: "Vivo",
  },
  buzzingwilds3: {
    href: "/casino/pragmaticplay-3-buzzing-wilds",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/3BuzzingWilds.webp",
    alt: "3 Buzzing Wilds",
    name: "3 Buzzing Wilds",
    providerName: "Vivo",
  },
  nights1001: {
    href: "/casino/pragmaticplay-1001-nights",
    code: "",
    casino: "Slots",
    provider: "Pragmatic Play",
    homeUrl: pageUrlGenerator("/home"),
    imgUrl: "/images/pragmaticplay/1001Nights.webp",
    alt: "1001 Nights",
    name: "1001 Nights",
    providerName: "Vivo",
  },
};
